import { ProductWithOptionsAndMeta, SwatchesProductsMap } from "../../components/SwatchesModal/SwatchesSelector";
import { BACKEND_URL } from "../../config";
import type { BadgeType } from "../Cart/CartTypes";
import { getStoreContext, IS_METAL_BIRD_SHOP } from "../constants";
import {
    BBTierOptions,
    BundleBuilderConfigInterface,
    BuyNConfigInterface,
    BuyNOptions,
    BxgyConfigInterface,
    custom_field,
    FBTConfigInterface,
    FreeGiftStepType,
    mix_match_section,
    MixMatchConfigInterface,
    MixMatchOption,
    PlaceholderConfigInterface,
    ProductAddonsConfigInterface,
    ProductAddonsPopupConfigInterface,
    ProductObj,
    ReviewStepType,
    StandardConfigInterface,
    StepsType,
    SwatchOption,
    VolumeConfigInterface,
    FixedBoxConfig,
    OfferInterface,
    MixMatchSectionalConfigInterface,
} from "./Types";
import { v4 as uuidv4 } from "uuid";
import { MdFiberManualRecord, MdStar, MdFavorite, MdThumbUp } from "react-icons/md";
import { FaCheck, FaArrowRight } from "react-icons/fa";
import type { IconType } from "react-icons";

export const BundleTypes = {
    BXGY: "bxgy",
    STANDARD: "standard",
    VOLUME_DISCOUNT: "volume",
    MIX_MATCH: "mixmatch",
    FBT: "fbt",
    PRODUCT_ADDONS: "product_add_on",
    AI_BUNDLES: "ai_bundles",
    BXGY_SECTIONAL: "bxgy-sectional",
    BUNDLE_BUILDER: "bundle_builder",
    BB_PLACEHOLDER: "bb_placeholder",
    BUNDLE_BUILDER_CTA: "bundle_builder_cta",
    OFFERS: "bundles",
    SLIDE_CART: "slide-cart",
    THANKYOUPAGE: "thank-you-page",
    PRODUCT_ADDONS_POPUP: "product_add_on_popup",
    MIX_MATCH_SECTIONAL: "mixmatch_sectional",
    BUY_N: "buy_n",
} as const;

export const ATTRIBUTE_KEY_SHORTCODES: Record<string, string> = {
    __upsell: "us",
    __freeGiftRewards: "fg",
    __additional_products: "ap",
    __thankyou_page_id: "ty",
    __bundle_builder_fields: "bf",
    __mnm_message: "mm",
    __kbd: "__KF",
    __volume: "vl",
    __standard: "st",
    __fbt: "fb",
    __add_on: "ao",
    __add_on_popup: "aop",
    form_id: "fi",
    required_product: "rp",
    cart_upsell_offer_id: "Cu",
    cart_id: "ci",
    __mix_match: "mx",
    __buy_n: "bn",
    __bxgy: "by",
    __triggerRewards: "tr",
    __offerIndex: "oi",
    __volumeFreeGift: "vfg",
    __volumeBundleProduct: "vbp",
    __volumeUpsellProduct: "vup",
};

// export const ATTRIBUTE_KEYS = Object.keys(ATTRIBUTE_KEY_SHORTCODES).reduce((acc, key) => {
//     acc[key] = key;
//     return acc;
// }, {} as Record<string, string>);
// Example:
//  const ATTRIBUTE_KEYS = {
//   __upsell: "__upsell",
//   __freeGiftRewards: "__freeGiftRewards",
//   __additional_products: "__additional_products",
//   __thankyou_page_id: "__thankyou_page_id",
//   __bundle_builder_fields: "__bundle_builder_fields",
// }

// Reverse lookup
// export const ATTRIBUTE_KEY_SHORTCODES_REVERSE: Record<string, string> = Object.entries(ATTRIBUTE_KEY_SHORTCODES).reduce(
//     (acc, [longKey, shortKey]) => {
//         acc[shortKey] = longKey;
//         return acc;
//     },
//     {} as Record<string, string>,
// );
// Example:
// ATTRIBUTE_KEY_SHORTCODES_REVERSE = {
// us: "__upsell",
//   fg: "__freeGiftRewards",
//   ap: "__additional_products",
//   ty: "__thankyou_page_id",
//   bf: "__bundle_builder_fields",
// };

// export function parseAttributeValue(raw: string): Record<string, any> {
//     if (!raw || typeof raw !== "string") return {};

//     try {
//         return JSON.parse(raw);
//     } catch {}

//     try {
//         let fixed = raw.replace(/=>/g, ":");

//         // quote unquoted keys
//         fixed = fixed.replace(/([{,\s])([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');

//         return JSON.parse(fixed);
//     } catch {
//         return {};
//     }
// }

// function reverseKeysDeep(obj: any): any {
//     if (obj === null || typeof obj !== "object") return obj;

//     const result: Record<string, any> = {};

//     for (const [k, v] of Object.entries(obj)) {
//         const oldKey = ATTRIBUTE_KEY_SHORTCODES_REVERSE[k] || k;
//         result[oldKey] = reverseKeysDeep(v);
//     }

//     return result;
// }

// export function normalizeCustomAttributes(customAttrs: any[]): any[] {
//     if (!Array.isArray(customAttrs)) return [];

//     // Find KF attribute (shortcode for __kbd)
//     const kfAttr = customAttrs.find((a) => a.key === ATTRIBUTE_KEY_SHORTCODES.__kbd);

//     if (!kfAttr || !kfAttr.value) return customAttrs;
//     const parsed = parseAttributeValue(kfAttr.value);
//     if (!parsed || typeof parsed !== "object") return customAttrs;

//     // Reverse ALL keys (top + nested)
//     const reversedParsed = reverseKeysDeep(parsed);

//     const reversedAttrs = Object.entries(reversedParsed).map(([key, value]) => ({
//         key,
//         value: typeof value === "string" ? value : JSON.stringify(value),
//     }));

//     // Convert KF to __kbd AND reverse its value too
//     const kfOldKey = ATTRIBUTE_KEY_SHORTCODES_REVERSE[kfAttr.key] || kfAttr.key;

//     reversedAttrs.push({
//         key: kfOldKey,
//         value: JSON.stringify(reversedParsed),
//     });

//     return [...customAttrs, ...reversedAttrs];
// }

export const DISCOUNT_TYPES = {
    PERCENTAGE: "percentage",
    FLAT: "flat",
    FIXED: "fixed",
    NONE: "none",
    TIER: "tier",
    FIXED_BOXES: "fixed_boxes",
} as const;

export const AvailableVolumeTemplates = {
    HORIZONTAL_BASIC: "horizontal_basic",
    HORIZONTAL_MODERN: "horizontal_modern",
    VERTICAL_BASIC: "vertical_basic",
    VERTICAL_MODERN: "vertical_modern",
    VERTICAL_CLASSIC: "vertical_classic",
    VERTICAL_ELEGANT: "vertical_elegant",
};

export const AvailableCartDrawerTemplates = {
    BASIC_LAYOUT: "basic_layout",
    DIVINE: "divine_layout",
    MODERN: "modern_layout",
} as const;
export type CartDrawerTemplatesTypes = (typeof AvailableCartDrawerTemplates)[keyof typeof AvailableCartDrawerTemplates];

export const AvailableCartFooterLayouts = {
    HORIZONTAL: "horizontal",
    VERTICAL: "vertical",
} as const;
export type CartDrawerFooterTypes = (typeof AvailableCartFooterLayouts)[keyof typeof AvailableCartFooterLayouts];

export const AvailableStandardTemplates = {
    HORIZONTAL_BASIC: "horizontal_basic",
    VERTICAL_BASIC: "vertical_basic",
    VERTICAL_CLASSIC: "vertical_classic",
};
export const AvailableBundleBuilderTemplates = {
    FULL_CARD_INFO: "full_card_info",
    BASIC_CARD_INFO: "basic_card_info",
    IMG_FOCUS_CARD: "img_focus_card",
    HOVER_ACTION_CARD: "hover_action_card",
    HOVER_INFO_CARD: "hover_info_card",
};
export const AvailableProductAddonsTemplates = {
    HORIZONTAL_BASIC: "horizontal_basic",
    VERTICAL_BASIC: "vertical_basic",
    VERTICAL_CLASSIC: "vertical_classic",
};

export const AvailableBXGYTemplates = {
    HORIZONTAL_BASIC: "horizontal_basic",
    VERTICAL_CLASSIC: "vertical_classic",
};

export const AvailableFBTTemplates = {
    HORIZONTAL: "horizontal",
    VERTICAL: "vertical",
};

export type DiscountTypes = (typeof DISCOUNT_TYPES)[keyof typeof DISCOUNT_TYPES];

export const getDiscountOptions = (currencySymbol: string) => [
    { label: "Percentage discount %", value: DISCOUNT_TYPES.PERCENTAGE },
    {
        label: `Fixed amount discount ${currencySymbol}`,
        value: DISCOUNT_TYPES.FLAT,
    },
    {
        label: `Fixed bundle price ${currencySymbol}`,
        value: DISCOUNT_TYPES.FIXED,
    },
    { label: "Without discount", value: DISCOUNT_TYPES.NONE },
];

export const getDiscountOptionsBB = (currencySymbol: string) => [
    { label: "Percentage discount %", value: DISCOUNT_TYPES.PERCENTAGE },
    // {
    //     label: `Tier discounts`,
    //     value: DISCOUNT_TYPES.TIER,
    // },
    {
        label: `Fixed amount discount ${currencySymbol}`,
        value: DISCOUNT_TYPES.FLAT,
    },

    {
        label: `Fixed bundle price ${currencySymbol}`,
        value: DISCOUNT_TYPES.FIXED,
    },
    { label: "Without discount", value: DISCOUNT_TYPES.NONE },
];

export const getDiscountOptionsCartUpsells = (currencySymbol: string) => [
    { label: "Percentage discount %", value: DISCOUNT_TYPES.PERCENTAGE },
    {
        label: `Fixed amount discount ${currencySymbol}`,
        value: DISCOUNT_TYPES.FLAT,
    },

    { label: "Without discount", value: DISCOUNT_TYPES.NONE },
];

export const getDiscountOptionsBXGY = (currencySymbol: string) => [
    { label: "Percentage discount %", value: DISCOUNT_TYPES.PERCENTAGE },
    {
        label: `Fixed amount discount ${currencySymbol}`,
        value: DISCOUNT_TYPES.FLAT,
    },
    {
        label: `Fixed Discounted Products(Y) Price ${currencySymbol}`,
        value: DISCOUNT_TYPES.FIXED,
    },
    { label: "Without discount", value: DISCOUNT_TYPES.NONE },
];

export const getDiscountOptionsAddons = (currencySymbol: string, disableFlat: boolean) => [
    { label: "Percentage discount %", value: DISCOUNT_TYPES.PERCENTAGE },
    {
        label: `Fixed amount discount ${currencySymbol}`,
        value: DISCOUNT_TYPES.FLAT,
        disabled: disableFlat,
    },
    { label: "Without discount", value: DISCOUNT_TYPES.NONE },
];

export const getDiscountOptionsAddonsPopup = () => [
    { label: "Percentage discount %", value: DISCOUNT_TYPES.PERCENTAGE },
    { label: "Without discount", value: DISCOUNT_TYPES.NONE },
];

export const getDiscountOptionsThankyou = () => [
    { label: "Percentage", value: DISCOUNT_TYPES.PERCENTAGE },
    {
        label: `Fixed Discount`,
        value: DISCOUNT_TYPES.FIXED,
    },
    { label: "Without discount", value: DISCOUNT_TYPES.NONE },
];

export const getDiscountOptionsWIthoutFixed = (currencySymbol: string) => [
    { label: "Percentage discount %", value: DISCOUNT_TYPES.PERCENTAGE },
    {
        label: `Fixed amount discount ${currencySymbol}`,
        value: DISCOUNT_TYPES.FLAT,
    },
    { label: "Without discount", value: DISCOUNT_TYPES.NONE },
];

export const BUNDLE_POSITIONS = {
    "BELOW-ADD_TO_CART": "below-add_to_cart",
    "ABOVE-ADD_TO_CART": "above-add_to_cart",
    "BELOW-CUSTOM_ELEMENT": "below-custom_element",
    "ABOVE-CUSTOM_ELEMENT": "above-custom_element",
    "BELOW-MULTI_CUSTOM_ELEMENT": "below-multi_custom_element",
    "ABOVE-MULTI_CUSTOM_ELEMENT": "above-multi_custom_element",
    "PRODUCT_PAGE_PLACEHOLDER-SHOPIFY_THEME_2": "product_page_placeholder-shopify_theme_2",
} as const;

export type BundlePositionsTypes = (typeof BUNDLE_POSITIONS)[keyof typeof BUNDLE_POSITIONS];
export const BundlePositions = [
    {
        label: "Below Add-to-cart Form(Default)",
        value: BUNDLE_POSITIONS["BELOW-ADD_TO_CART"],
    },
    {
        label: "Above Add-to-cart Form",
        value: BUNDLE_POSITIONS["ABOVE-ADD_TO_CART"],
    },
    {
        label: "Below Custom Element",
        value: BUNDLE_POSITIONS["BELOW-CUSTOM_ELEMENT"],
    },
    {
        label: "Above custom Element",
        value: BUNDLE_POSITIONS["BELOW-CUSTOM_ELEMENT"],
    },
    {
        label: "Below multiple Custom Element",
        value: BUNDLE_POSITIONS["BELOW-MULTI_CUSTOM_ELEMENT"],
    },
    {
        label: "Above multiple custom Element",
        value: BUNDLE_POSITIONS["ABOVE-MULTI_CUSTOM_ELEMENT"],
    },
    {
        label: "Product page placeholder - shopify Theme 2.0",
        value: BUNDLE_POSITIONS["PRODUCT_PAGE_PLACEHOLDER-SHOPIFY_THEME_2"],
    },
];

export const REDIRECT_OPTIONS = {
    CHECKOUT: "checkout",
    CART: "cart",
    NONE: "none",
} as const;

export type RedirectOptionsTypes = (typeof REDIRECT_OPTIONS)[keyof typeof REDIRECT_OPTIONS] | "";

export interface GeneralSettingObj {
    show_bundle_on_product_page?: boolean;
    show_multiple_bundles_on_product_page?: boolean;
    redirect_after_adding_product_to_cart?: RedirectOptionsTypes;
    redirect_to_checkout: boolean;
    show_powered_by_kefi: boolean;
    max_width?: number;
    override_max_width?: boolean;
    override_margin_top?: boolean;
    margin_top?: number;
    bundle_alignment?: "flex-start" | "center" | "flex-end";
    show_carousel?: boolean;
    auto_rotate_carousel?: boolean;
    carousel_interval?: string;
}
type FetchProductsResult = {
    products: { id: string; title: string }[];
    nextCursor: string | null;
};

export const WIDGET_SHOW_OPTIONS = {
    SHOW_EVERYWHERE: "show_everywhere",
    HIDE_EVERYWHERE: "hide_everywhere",
    HIDE_PRODUCT_PAGE: "hide_product_page",
    val: "",
} as const;
export type WidgetShowOptionsTypes = (typeof WIDGET_SHOW_OPTIONS)[keyof typeof WIDGET_SHOW_OPTIONS];

export const WidgetShowOptions = [
    { label: "Show everywhere", value: WIDGET_SHOW_OPTIONS.SHOW_EVERYWHERE },
    { label: "Hide everywhere", value: WIDGET_SHOW_OPTIONS.HIDE_EVERYWHERE },
    {
        label: "Hide on product page",
        value: WIDGET_SHOW_OPTIONS.HIDE_PRODUCT_PAGE,
    },
];

export const HEADER_HEIGHT_OPT = {
    SMALL: "header_small",
    MEDIUM: "header_medium",
    LARGE: "header_large",
} as const;
export type HeaderHeightTypes = (typeof HEADER_HEIGHT_OPT)[keyof typeof HEADER_HEIGHT_OPT];

export const HeaderHeightOptions = [
    { label: "Small", value: HEADER_HEIGHT_OPT.SMALL },
    { label: "Medium", value: HEADER_HEIGHT_OPT.MEDIUM },
    {
        label: "Large",
        value: HEADER_HEIGHT_OPT.LARGE,
    },
];

export const CART_WIDTH_OPT = {
    COMPACT: "cart_width_small",
    STANDARD: "cart_width_medium",
    EXPANDED: "cart_width_large",
} as const;
export type CartWidthTypes = (typeof CART_WIDTH_OPT)[keyof typeof CART_WIDTH_OPT];

export const CartWidthOptions = [
    // { label: "Compact", value: CART_WIDTH_OPT.COMPACT },
    { label: "Standard", value: CART_WIDTH_OPT.STANDARD },
    {
        label: "Expanded",
        value: CART_WIDTH_OPT.EXPANDED,
    },
];

export const BB_OFFER_CTA_POSITION_OPT = {
    BELOW_CART: "below_cart",
    ABOVE_CART: "above_cart",
    FBT_DEFAULT: "fbt_default",
    BELOW_ELEMENT: "below_element",
    ABOVE_ELEMENT: "above_element",
    PRODUCT_PAGE_PLACEHOLDER: "placeholder",
} as const;
export type BbOfferCtaPositionsType = (typeof BB_OFFER_CTA_POSITION_OPT)[keyof typeof BB_OFFER_CTA_POSITION_OPT];

export const BbOfferCtaPositionOptions = [
    { label: "Below Add-to-Cart (Default)", value: BB_OFFER_CTA_POSITION_OPT.BELOW_CART },
    { label: "Above Add-to-Cart", value: BB_OFFER_CTA_POSITION_OPT.ABOVE_CART },
    { label: "Below Custom Element", value: BB_OFFER_CTA_POSITION_OPT.BELOW_ELEMENT },
    { label: "Above Custom Element", value: BB_OFFER_CTA_POSITION_OPT.ABOVE_ELEMENT },
    {
        label: "Select Position Visually with Shopify Theme editor",
        value: BB_OFFER_CTA_POSITION_OPT.PRODUCT_PAGE_PLACEHOLDER,
    },
];

const UPSELLS_LAYOUT_OPT = {
    CAROUSEL: "carousel",
    STACKED: "stacked",
} as const;

export type UpsellsLayoutType = (typeof UPSELLS_LAYOUT_OPT)[keyof typeof UPSELLS_LAYOUT_OPT];

export const UpsellsLayout = [
    { label: "Carousel View", value: UPSELLS_LAYOUT_OPT.CAROUSEL },
    { label: "Stacked Blocks", value: UPSELLS_LAYOUT_OPT.STACKED },
];

export const RewardBasis = [
    { label: "Cart Total", value: "cart_total" },
    { label: "Total Items", value: "item_count" },
];
export const RewardTypes = [
    { label: "Discount", value: "discount" },
    { label: "Free Gift", value: "product" },
    { label: "Free Shipping", value: "free_shipping" },
];

export const FbtProductLimits = [
    {
        label: "2 products (Main product + 1 AI suggested product)",
        value: 2 as unknown as string,
    },
    {
        label: "3 products (Main product + 2 AI suggested products)",
        value: 3 as unknown as string,
    },
    {
        label: "4 products (Main product + 3 AI suggested products)",
        value: 4 as unknown as string,
    },
    {
        label: "5 products (Main product + 4 AI suggested products)",
        value: 5 as unknown as string,
    },
    {
        label: "6 products (Main product + 5 AI suggested products)",
        value: 6 as unknown as string,
    },
];

const FONT_STYLES_OPT = {
    LIGHT: "350 normal",
    LIGHT_ITALIC: "350 italic",
    REGULAR: "450 normal",
    ITALIC: "450 italic",
    MEDIUM: "550 normal",
    MEDIUM_ITALIC: "550 italic",
    SEMI_BOLD: "650 normal",
    SEMI_BOLD_ITALIC: "650 italic",
    BOLD: "750 normal",
    BOLD_ITALIC: "750 italic",
} as const;

export type FontStylesTypes = (typeof FONT_STYLES_OPT)[keyof typeof FONT_STYLES_OPT];

export const FontStyles = [
    { label: "Light", value: FONT_STYLES_OPT.LIGHT },
    { label: "Light Italic", value: FONT_STYLES_OPT.LIGHT_ITALIC },
    { label: "Regular", value: FONT_STYLES_OPT.REGULAR },
    { label: "Italic", value: FONT_STYLES_OPT.ITALIC },
    { label: "Medium", value: FONT_STYLES_OPT.MEDIUM },
    { label: "Medium Italic", value: FONT_STYLES_OPT.MEDIUM_ITALIC },
    { label: "Semi Bold", value: FONT_STYLES_OPT.SEMI_BOLD },
    { label: "Semi Bold Italic", value: FONT_STYLES_OPT.SEMI_BOLD_ITALIC },
    { label: "Bold", value: FONT_STYLES_OPT.BOLD },
    { label: "Bold Italic", value: FONT_STYLES_OPT.BOLD_ITALIC },
];

export const WIDGET_POSITIONS_OPT = {
    BELOW_CART: "below_cart",
    ABOVE_CART: "above_cart",
    FBT_DEFAULT: "fbt_default",
    BELOW_ELEMENT: "below_element",
    ABOVE_ELEMENT: "above_element",
    PRODUCT_PAGE_PLACEHOLDER: "placeholder",
} as const;

export type WidgetPositionsTypes = (typeof WIDGET_POSITIONS_OPT)[keyof typeof WIDGET_POSITIONS_OPT];

export const WidgetPositions = [
    { label: "Below Shopify Sections (Default)", value: WIDGET_POSITIONS_OPT.FBT_DEFAULT },
    { label: "Below Add-to-Cart (Default)", value: WIDGET_POSITIONS_OPT.BELOW_CART },
    { label: "Above Add-to-Cart", value: WIDGET_POSITIONS_OPT.ABOVE_CART },
    { label: "Below Custom Element", value: WIDGET_POSITIONS_OPT.BELOW_ELEMENT },
    { label: "Above Custom Element", value: WIDGET_POSITIONS_OPT.ABOVE_ELEMENT },
    {
        label: "Select Position Visually with Shopify Theme editor",
        value: WIDGET_POSITIONS_OPT.PRODUCT_PAGE_PLACEHOLDER,
    },
];

export const WidgetPositionsVolume = [
    { label: "Above Add-to-Cart (Default)", value: WIDGET_POSITIONS_OPT.ABOVE_CART },
    { label: "Below Add-to-Cart", value: WIDGET_POSITIONS_OPT.BELOW_CART },
    { label: "Below Custom Element", value: WIDGET_POSITIONS_OPT.BELOW_ELEMENT },
    { label: "Above Custom Element", value: WIDGET_POSITIONS_OPT.ABOVE_ELEMENT },
    {
        label: "Select Position Visually with Shopify Theme editor",
        value: WIDGET_POSITIONS_OPT.PRODUCT_PAGE_PLACEHOLDER,
    },
];

export const BUNDLE_VISIBILITY_OPT = {
    ALL_SELECTED_PRODUCT_PAGES: "all_selected_product_pages",
    NO_PRODUCT_PAGES: "no_product_pages",
} as const;

export type BundleVisibilityTypes = (typeof BUNDLE_VISIBILITY_OPT)[keyof typeof BUNDLE_VISIBILITY_OPT];

export const BundleVisibilityOptions = [
    { label: "All selected product pages", value: BUNDLE_VISIBILITY_OPT.ALL_SELECTED_PRODUCT_PAGES },
    { label: "No product pages", value: BUNDLE_VISIBILITY_OPT.NO_PRODUCT_PAGES },
];

export const WidgetPositionsAddons = [
    { label: "Above Add-to-Cart (Default)", value: WIDGET_POSITIONS_OPT.ABOVE_CART },
    { label: "Below Add-to-Cart", value: WIDGET_POSITIONS_OPT.BELOW_CART },
    { label: "Below Custom Element", value: WIDGET_POSITIONS_OPT.BELOW_ELEMENT },
    { label: "Above Custom Element", value: WIDGET_POSITIONS_OPT.ABOVE_ELEMENT },
    {
        label: "Select Position Visually with Shopify Theme editor",
        value: WIDGET_POSITIONS_OPT.PRODUCT_PAGE_PLACEHOLDER,
    },
];

export const DefaultWidgetPositions = {
    [BundleTypes.VOLUME_DISCOUNT]: "Above Add to Cart Button",
    [BundleTypes.FBT]: "Below Shopify Product Section",
    [BundleTypes.PRODUCT_ADDONS]: "Above Add to Cart Button",
    [BundleTypes.MIX_MATCH_SECTIONAL]: "Below Add to Cart Button",
    [BundleTypes.STANDARD]: "Below Add to Cart Button",
    [BundleTypes.BXGY]: "Below Add to Cart Button",
    [BundleTypes.MIX_MATCH]: "Below Add to Cart Button",
    [BundleTypes.BUY_N]: "Below Add to Cart Button",
    [BundleTypes.BUNDLE_BUILDER]: "Below Add to Cart Button",
    [BundleTypes.BUNDLE_BUILDER_CTA]: "Below Add to Cart Button",
    [BundleTypes.BB_PLACEHOLDER]: "Below Add to Cart Button",
} as Record<string, string>;

const IMAGE_SIZES_OPT = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
} as const;

export type ImageSizesTypes = (typeof IMAGE_SIZES_OPT)[keyof typeof IMAGE_SIZES_OPT];
export const ImageSizes = [
    { label: "Small", value: IMAGE_SIZES_OPT.SMALL },
    { label: "Medium", value: IMAGE_SIZES_OPT.MEDIUM },
    { label: "Large", value: IMAGE_SIZES_OPT.LARGE },
];

export const IMAGE_DISPLAY_OPT = {
    ALL: "all",
    DESKTOP: "desktop",
    NONE: "none",
} as const;
export type ImageDisplayTypes = (typeof IMAGE_DISPLAY_OPT)[keyof typeof IMAGE_DISPLAY_OPT];
export const ImageDisplays = [
    { label: "Desktop/Mobile", value: IMAGE_DISPLAY_OPT.ALL },
    { label: "Desktop", value: IMAGE_DISPLAY_OPT.DESKTOP },
    { label: "None", value: IMAGE_DISPLAY_OPT.NONE },
];

export const CUSTOM_HTML_POS_OPT = {
    BELOW_CHECKOUT: "below_checkout",
    ABOVE_CHECKOUT: "above_checkout",
    ABOVE_ANNOUNCEMENT: "above_announcement",
    BELOW_BADGES: "below_badges",
} as const;

export type CustomHtmlPosTypes = (typeof CUSTOM_HTML_POS_OPT)[keyof typeof CUSTOM_HTML_POS_OPT];
export const CustomHtmlPositions = [
    { label: "Below Checkout Button", value: CUSTOM_HTML_POS_OPT.BELOW_CHECKOUT },
    { label: "Above Checkout Button ", value: CUSTOM_HTML_POS_OPT.ABOVE_CHECKOUT },
    { label: "Above Announcement", value: CUSTOM_HTML_POS_OPT.ABOVE_ANNOUNCEMENT },
    { label: "Below Badges", value: CUSTOM_HTML_POS_OPT.BELOW_BADGES },
];

export function isValidLink(link: string) {
    let url;

    try {
        url = new URL(link);
    } catch (_) {
        return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
}

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export const validateHexalColor = (val = "", fieldName = "") => {
    if (!val.length) {
        const baseMsg = fieldName ? `${fieldName} color value cannot be empty` : "Value cannot be empty";
        return capitalize(baseMsg);
    }

    const hexColorPattern = /^#([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;

    if (!hexColorPattern.test(val)) {
        const baseMsg = fieldName ? `${fieldName} invalid color input` : "Invalid color input";
        return capitalize(baseMsg);
    }

    return "";
};

export const validateTrustBadges = (val: BadgeType[]): string => {
    const selectedCount = val.filter((badge) => badge.selected).length;
    return selectedCount === 0 ? "Select at least one trust badge" : "";
};

export const validateTextLength = (val = "", fieldName = "") => {
    if (!val.length) {
        const msg = fieldName ? `${fieldName} is required` : "Value is required";
        return capitalize(msg);
    }
    if (val.length <= 3) {
        const msg = fieldName ? `${fieldName} min is 4` : "Min is 4";
        return capitalize(msg);
    }
    return "";
};

export const validateFontSize = (val: any = "", fieldName = "", range: null | { min: number; max: number } = null) => {
    if (val === "" || val === null || val === undefined) {
        const msg = fieldName ? `${fieldName} value cannot be empty` : "Value cannot be empty";
        return capitalize(msg);
    }
    const fontSize = +val;
    if (isNaN(fontSize)) {
        const msg = fieldName ? `${fieldName} invalid font size` : "Invalid font size";
        return capitalize(msg);
    }
    if (range && fontSize < range.min) {
        return capitalize(`Min: ${range.min}`);
    }
    if (range && fontSize > range.max) {
        return capitalize(`Max: ${range.max}`);
    }
    if (range == null && fontSize > 50) {
        return capitalize("Font is too large.");
    }
    if (range == null && fontSize < 1) {
        return capitalize("Font is too small.");
    }
    return "";
};

export const nonEmptyOverride = (val: string | undefined, msg: string) => {
    const value = val?.toString();
    if (!value?.trim()?.length) {
        return msg;
    } else {
        return "";
    }
};

const getCapacityValue = (value: string | number | null | undefined): number | null => {
    if (value == null) return null;

    const match = String(value)?.match(/\d+(\.\d+)?/);
    return match ? Number(match[0]) : null;
};

export const validateSubSteps = (step: StepsType): string | undefined => {
    const {
        subSteps,
        // @ts-expect-error required
        stepIdx,
    } = step;
    for (let i = 0; i < subSteps.length; i++) {
        const subStep = subSteps[i];
        if (!subStep?.step_label?.trim()) {
            return `Step ${stepIdx} -> Category ${i + 1}: Category label is required`;
        }

        if (!["specific", "collection"].includes(subStep?.product_selection)) {
            return `Step ${stepIdx} -> Category ${i + 1}: Invalid product selection`;
        }

        if (subStep?.product_selection === "specific" && (!subStep?.products || subStep?.products.length === 0)) {
            return `Step ${stepIdx} -> Category ${
                i + 1
            }: At least one product must be selected for 'Specific Products' selection`;
        }

        if (
            subStep?.product_selection === "collection" &&
            (!subStep?.collections || subStep?.collections.length === 0)
        ) {
            return `Step ${stepIdx} -> Category ${
                i + 1
            }: At least one collection must be selected for 'Collection' selection`;
        }

        if (!["min_products", "max_products", "exact_products"].includes(subStep?.subStep_condition_type)) {
            return `Step ${stepIdx} -> Category ${i + 1}: Invalid condition type`;
        }

        if (+subStep.product_count_limit <= 0) {
            return `Step ${stepIdx} -> Category ${i + 1}: ${
                subStep?.subStep_condition_basis == "bundle_total" ? "Amount" : "Items count"
            } must be greater than zero`;
        }

        // if (!subStep?.step_error_msg?.trim()) {
        //     return `Step ${stepIdx} -> SubStep ${numberToLetters(i)}: Error message is required`;
        // }
    }

    return ""; // All substeps are valid
};

export const validateStepCondition = (step: StepsType): string | undefined => {
    const {
        step_conditions,
        // @ts-expect-error required
        stepIdx,
    } = step;

    const seen = new Set<string>();

    for (let i = 0; i < step_conditions?.length; i++) {
        const stepCondition = step_conditions[i];
        const key = `${stepCondition.basis}_${stepCondition.type}`;

        if (+stepCondition?.limit <= 0) {
            return `Step ${stepIdx} -> Condition ${i + 1}: ${
                stepCondition.basis == "bundle_total" ? "Amount" : "Items count"
            } must be greater than zero`;
        }
        if (seen.has(key)) {
            return `Step ${stepIdx} -> Condition ${i + 1}: Duplicate condition found`;
        }
        seen.add(key);
    }
    return "";
};

export const validateSteps = (steps: StepsType[]): string | undefined => {
    for (let i = 0; i < steps?.length; i++) {
        console._log(`asdfasdf validateSteps ${i}`, steps[i]);
        const step = steps[i];

        if (!step?.step_label?.trim()) {
            return `Step ${i + 1}: Step title is required`;
        }

        if (!["fields", "products", "free_gift"].includes(step?.step_content_type)) {
            return `Step ${i + 1}: Invalid content type`;
        }

        if (!["specific", "collection"].includes(step?.product_selection)) {
            return `Step ${i + 1}: Invalid product selection`;
        }

        if (
            (step?.step_content_type === "products" || step?.step_content_type === "free_gift") &&
            !step?.enable_subSteps
        ) {
            if (step?.product_selection === "specific" && (!step?.products || step?.products.length === 0)) {
                return `Step ${i + 1}: At least one product must be selected for 'Specific Products' selection`;
            }

            if (step?.product_selection === "collection" && (!step?.collections || step?.collections.length === 0)) {
                return `Step ${i + 1}: At least one collection must be selected for 'Collection' selection`;
            }
        }
        if (step?.enable_subSteps) {
            if (step?.subSteps?.length == 0) {
                return `Step ${i + 1}: At least one Category must be added`;
            } else {
                // @ts-expect-error required
                const subStepValidationError = validateSubSteps({ ...step, stepIdx: i + 1 });
                if (subStepValidationError) return subStepValidationError;
            }
        }

        if (step?.step_conditions) {
            if (step?.step_conditions?.length == 0) {
                return `Step ${i + 1}: At least one Step Condition must be added`;
            } else {
                // @ts-expect-error required
                const stepConditionValidationError = validateStepCondition({ ...step, stepIdx: i + 1 });
                if (stepConditionValidationError) return stepConditionValidationError;
            }
        }

        if (step?.step_content_type === "fields") {
            if (!step?.fields || step?.fields?.length === 0) {
                return `Step ${i + 1}: At least one field is required`;
            }

            for (let j = 0; j < step?.fields?.length; j++) {
                const field = step?.fields[j];

                if (!["input", "textarea", "dropdown", "file_upload"].includes(field.field_type)) {
                    return `Step ${i + 1}, Field ${j + 1}: Invalid field type`;
                }

                if (!field.field_title?.trim()) {
                    return `Step ${i + 1}, Field ${j + 1}: Field title is required`;
                }

                // if (!field.field_placeholder?.trim()) {
                //     return `Step ${i + 1}, Field ${j + 1}: Field placeholder is required`;
                // }
                if (field.field_type === "dropdown") {
                    if (!field.dropdown_options || field.dropdown_options.length === 0) {
                        return `Step ${i + 1}, Field ${j + 1}: At least one option is required for dropdown fields`;
                    }
                }
                if (field.field_type === "file_upload") {
                    if (
                        !field.file_upload_settings?.allowed_file_types ||
                        field.file_upload_settings?.allowed_file_types?.length === 0
                    ) {
                        return `Step ${i + 1}, Field ${j + 1}: At least one file type must be selected`;
                    }
                }
            }
        }
        // if (step?.step_error_msg?.length == 0) {
        //     return `Step ${i + 1}: Error message is required`;
        // }
    }

    return ""; // All steps are valid
};

export function numberToLetters(n: number): string {
    let result = "";
    while (n >= 0) {
        result = String.fromCharCode((n % 26) + 65) + result;
        n = Math.floor(n / 26) - 1;
    }
    return result;
}

export const validateReviewStep = (value: ReviewStepType) => {
    if (value?.is_enabled) {
        if (value?.step_label?.length == 0) {
            return "Review Step Page Title is required";
        }

        // Validate add-on products
        if (value?.enable_addon_products) {
            if (!value?.addon_section_title || value.addon_section_title.trim().length === 0) {
                return "Add-on section title is required";
            }

            const selection = value?.addon_product_selection;

            if (selection === "specific") {
                if (!value?.addon_products || value?.addon_products?.length === 0) {
                    return "At least one product must be selected for 'Specific Products' selection";
                }
            }

            if (selection === "collection") {
                if (!value?.collections || value?.collections?.length === 0) {
                    return "At least one collection must be selected for 'Collection' selection";
                }
            }
        }
    } else {
        return "";
    }
};

export const validateFixedBoxes = (boxes: FixedBoxConfig[]): string | undefined => {
    const seen = new Set<number>();
    for (const box of boxes) {
        if (!box.boxName?.trim()) {
            return "Box name cannot be empty.";
        }
        if (box.itemsCount <= 0) {
            return "Items in box must be greater than zero.";
        }
        if (box.fixedPrice <= 0) {
            return "Fixed price must be greater than zero.";
        }
        if (seen.has(box.itemsCount)) {
            return "Duplicate quantity found in boxes. Each box must have a unique number of items.";
        }
        seen.add(box.itemsCount);
    }
    return undefined;
};

export const validateFreeGiftStep = (value: FreeGiftStepType): string | undefined => {
    if (!value?.is_enabled) return "";

    if (!value.step_label?.trim()) {
        return "Free Gift Step Label is required";
    }

    if (!["specific", "collection"].includes(value?.product_selection)) {
        return "Free Gift Step: Invalid product selection type";
    }

    if (value.product_selection === "specific" && (!value.products || value.products.length === 0)) {
        return "Free Gift Step: At least one product must be selected for 'Specific Products' selection";
    }

    if (value.product_selection === "collection" && (!value.collections || value.collections.length === 0)) {
        return "Free Gift Step: At least one collection must be selected for 'Collection' selection";
    }

    return ""; // All good
};

export type AdditionalProductType = "shipping_protection" | "gift_wrapping";

export type ProductRecommendationType = "RELATED" | "COMPLEMENTARY";

export const ProductRecommendationIntent = {
    RELATED: "RELATED" as ProductRecommendationType,
    COMPLEMENTARY: "COMPLEMENTARY" as ProductRecommendationType,
} as const;

export const getFbtProductRecommendations = async (
    storefrontAccessToken: string,
    _productId: string,
    bundleConfig: FBTConfigInterface | StandardConfigInterface | ProductAddonsPopupConfigInterface,
    _maxLimit: number,
    standalone?: boolean | undefined,
    _intent?: string,
    productList?: boolean,
) => {
    const onFailedCallback = () => {};
    if (!storefrontAccessToken) {
        onFailedCallback();
        return bundleConfig;
    }

    // so, we won't hit the graphql query
    if (!bundleConfig?.form_id) {
        return bundleConfig;
    }
    // console._log(productIds);
    const productId = _productId;
    const maxLimit = _maxLimit || 2;
    const context = getStoreContext(standalone);
    // COMPLEMENTARY;
    const query = `query ${context} {
  productRecommendations(productId: "${productId}",intent:${_intent || ProductRecommendationIntent.RELATED}
) {
    id
    title
    handle
  }
}`;

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontAccessToken);
    myHeaders.append("Cookie", "request_method=POST");

    const raw = JSON.stringify({
        query,
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        // redirect: "follow",
    };
    try {
        const userShopname = !standalone ? shopify.config.shop : window.kefi_bundles.shop;
        const response = await fetch(`https://${userShopname}/api/2025-07/graphql.json`, requestOptions);
        const result = await response.json();
        if (result?.errors?.length) {
            onFailedCallback();
            return bundleConfig;
        }
        const data = result.data.productRecommendations;

        if (productList) {
            return data;
        } else {
            return {
                ...bundleConfig,
                products: [{ id: productId }],
                offered_products: data?.length ? [...data.filter((rec: any, idx: number) => idx < maxLimit - 1)] : [],
            };
        }
    } catch (error) {
        console.error("Error fetching products:", error);
        onFailedCallback();

        return bundleConfig;
    }
};

export const updateBundleConfigWithRealTimeProducts = async (
    storefrontAccessToken: string,
    bundleConfig: (
        | StandardConfigInterface
        | VolumeConfigInterface
        | BxgyConfigInterface
        | MixMatchConfigInterface
        | FBTConfigInterface
        | ProductAddonsConfigInterface
        | ProductAddonsPopupConfigInterface
        | BundleBuilderConfigInterface
        | BuyNConfigInterface
        | PlaceholderConfigInterface
    )[],
    standalone?: boolean | undefined,
    fetchCount: null | number = null,
    signal?: AbortSignal,
) => {
    const onFailedCallback = () => {
        bundleConfig.forEach((config) => {
            config?.products?.forEach((product: any) => {
                product.variants.forEach((variant: any) => {
                    variant.availableForSale = true;
                    variant.quantityAvailable = 1000;
                });
            });
            // @ts-expect-error required
            config?.offered_products?.forEach((product: any) => {
                product?.variants.forEach((variant: any) => {
                    variant.availableForSale = true;
                    variant.quantityAvailable = 1000;
                });
            });
            // @ts-expect-error required
            config?.discounted_products?.forEach((product: any) => {
                product?.variants.forEach((variant: any) => {
                    variant.availableForSale = true;
                    variant.quantityAvailable = 1000;
                });
            });
            // @ts-expect-error hack
            config?.free_gifts?.forEach((product: any) => {
                product?.variants.forEach((variant: any) => {
                    variant.availableForSale = true;
                    variant.quantityAvailable = 1000;
                });
            });
            // @ts-expect-error hack
            config?.pre_selected_products?.forEach((product: any) => {
                product?.variants?.forEach((variant: any) => {
                    variant.availableForSale = true;
                    variant.quantityAvailable = 1000;
                });
            });
            // @ts-expect-error required
            Object.values(config?.variant_addons || {}).forEach((products: any) => {
                products?.forEach((product: any) => {
                    product?.variants?.forEach((variant: any) => {
                        variant.availableForSale = true;
                        variant.quantityAvailable = 1000;
                    });
                });
            });
        });
    };

    if (!storefrontAccessToken) {
        onFailedCallback();
        return bundleConfig;
    }

    // so, we won't hit the graphql query
    if (bundleConfig?.length == 0) {
        return bundleConfig;
    }
    let productIds = bundleConfig
        ?.map((config) => {
            return [
                ...config.products.reduce((acc: string[], product: any) => {
                    if (product.id && typeof product.id === "string") {
                        const productId = product.id.split("/").pop();
                        if (productId) acc.push(productId);
                    }
                    return acc;
                }, []),
                // @ts-expect-error required
                ...(config?.offered_products
                    ? // @ts-expect-error required
                      config.offered_products.reduce((acc: string[], product: any) => {
                          if (product.id && typeof product.id === "string") {
                              const productId = product.id.split("/").pop();
                              if (productId) acc.push(productId);
                          }
                          return acc;
                      }, [])
                    : []),
                // @ts-expect-error required
                ...(config?.discounted_products?.length
                    ? // @ts-expect-error required
                      config.discounted_products.reduce((acc: string[], product: any) => {
                          if (product.id && typeof product.id === "string") {
                              const productId = product.id.split("/").pop();
                              if (productId) acc.push(productId);
                          }
                          return acc;
                      }, [])
                    : []),
                // @ts-expect-error hack
                ...(config.free_gifts?.length > 0
                    ? // @ts-expect-error hack
                      config.free_gifts.reduce((acc: string[], product: any) => {
                          if (product.id && typeof product.id === "string") {
                              const productId = product.id.split("/").pop();
                              if (productId) acc.push(productId);
                          }
                          return acc;
                      }, [])
                    : []),
                // @ts-expect-error hack
                ...(config?.mix_match_sections?.length > 0
                    ? // @ts-expect-error hack
                      config.mix_match_sections.reduce((acc: string[], section: any) => {
                          section.products.forEach((product: any) => {
                              if (product.id && typeof product.id === "string") {
                                  const productId = product.id.split("/").pop();
                                  if (productId) acc.push(productId);
                              }
                          });
                          return acc;
                      }, [])
                    : []),
                ...((config as VolumeConfigInterface).volume_discounts?.length > 0
                    ? (config as VolumeConfigInterface).volume_discounts.reduce(
                          (acc: string[], offer: OfferInterface) => {
                              offer?.bundle_products?.forEach((product: ProductObj) => {
                                  if (product.id && typeof product.id === "string") {
                                      const productId = product.id.split("/").pop();
                                      if (productId) acc.push(productId);
                                  }
                              });
                              offer?.free_gifts?.forEach((product: ProductObj) => {
                                  if (product.id && typeof product.id === "string") {
                                      const productId = product.id.split("/").pop();
                                      if (productId) acc.push(productId);
                                  }
                              });
                              offer?.upsell_products?.forEach((product: ProductObj) => {
                                  if (product.id && typeof product.id === "string") {
                                      const productId = product.id.split("/").pop();
                                      if (productId) acc.push(productId);
                                  }
                              });
                              return acc;
                          },
                          [],
                      )
                    : []),
                // @ts-expect-error hack
                ...(config?.pre_selected_products?.length > 0
                    ? // @ts-expect-error hack
                      config.pre_selected_products.reduce((acc: string[], product: any) => {
                          if (product.id && typeof product.id === "string") {
                              const productId = product.id.split("/").pop();
                              if (productId) acc.push(productId);
                          }
                          return acc;
                      }, [])
                    : []),
                // @ts-expect-error required
                ...(config?.variant_addons
                    ? // @ts-expect-error required
                      Object.values(config.variant_addons).reduce((acc: string[], products: any[]) => {
                          products?.forEach((product: any) => {
                              if (product.id && typeof product.id === "string") {
                                  const productId = product.id.split("/").pop();
                                  if (productId) acc.push(productId);
                              }
                          });
                          return acc;
                      }, [])
                    : []),
            ];
        })
        .flat();

    productIds = [...new Set(productIds)];

    let maxFetchCount = 250;

    if (productIds.length === 0) {
        if (standalone) {
            return bundleConfig;
        } else {
            maxFetchCount = 10;
        }
    }
    // console._log("Product IDs to fetch:", productIds);

    const productQuery = productIds.map((id: any) => `id:${id}`).join(" OR ");

    const context = getStoreContext(standalone);
    // console._log(productIds);

    const query = `
        query getProducts($query: String) ${context} {
            products(first: ${maxFetchCount}, query: $query) {
                nodes {
                    title
                    description
                    descriptionHtml
                    handle
                    id
                    tags
                    variantsCount {
                        count
                        precision
                    }
                    images(first: 10) { 
                        nodes {
                            id
                            url
                            altText
                        }
                    }
                    options{
                        id
                        name
                        values
                    }
                    metafield(namespace: "kefi_swatches", key: "swatches") {
                        value
                        type
                }
                 metafield2:metafield(namespace: "custom",key: "product_weight") {
                                value
                }
                 metafield3:metafield(namespace: "custom",key: "pre_order_expected_dispatch_mid_april") {
                                value
                }
                metafield4:metafield(namespace: "custom",key: "custom_text") {
                    value
                }
                metafield5:metafield(namespace: "custom",key: "product_description") {
                    value
                }
                metafield6:metafield(namespace: "custom",key: "weekly_dosage") {
                    value
                }
                    media(first: 50) {
                      edges {
                        node {
                          mediaContentType
                          alt
                          ... on MediaImage {
                            image {
                              url
                              altText
                            }
                          }
                          ... on Model3d {
                            sources {
                              url
                              mimeType
                              format
                              filesize
                            }
                          }
                          ... on Video {
                            sources {
                              url
                              mimeType
                              format
                              height
                              width
                            }
                          }
                          ... on ExternalVideo {
                            embeddedUrl
                          }
                        }
                      }
                    }
                    sellingPlanGroups(first: 10) {
                        nodes {
                            sellingPlans(first: 10) {
                                nodes {
                                    id
                                    name
                                    recurringDeliveries
                                    billingPolicy {
                                        __typename
                                        ... on SellingPlanRecurringBillingPolicy {
                                            interval
                                            intervalCount
                                        }
                                    }
                                    deliveryPolicy {
                                        __typename
                                        ... on SellingPlanRecurringDeliveryPolicy {
                                            interval
                                            intervalCount
                                        }
                                    }
                                    priceAdjustments {
                                        adjustmentValue {
                                            ... on SellingPlanFixedAmountPriceAdjustment {
                                                adjustmentAmount {
                                                    amount
                                                }
                                            }
                                            ... on SellingPlanFixedPriceAdjustment {
                                                price {
                                                    amount
                                                }
                                            }
                                            ... on SellingPlanPercentagePriceAdjustment {
                                                adjustmentPercentage
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    variants(first: ${VARIANTS_PAGE_SIZE}) {
                        ${VARIANTS_CONNECTION_FIELDS}
                    }
                    collections(first: 50){
                        nodes {
                            id
                        }
                    }
                }
            }
        }
    `;

    const variables = {
        query: productQuery,
    };

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontAccessToken);
    myHeaders.append("Cookie", "request_method=POST");

    const raw = JSON.stringify({
        query,
        variables,
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        signal,
        // redirect: "follow",
    };

    try {
        const userShopname = !standalone ? shopify.config?.shop : window.kefi_bundles?.shop;
        const response = await fetch(`https://${userShopname}/api/2025-07/graphql.json`, requestOptions);
        const result = await response.json();

        if (result?.errors?.length) {
            onFailedCallback();
            return bundleConfig;
        }

        const data = result?.data?.products;
        if (!data?.nodes?.length) {
            console.warn("Warning: No products returned from API.");
            onFailedCallback();
            return bundleConfig;
        }

        await fetchRemainingVariants(data.nodes, context, storefrontAccessToken, userShopname, signal);

        bundleConfig.forEach((config) => {
            if (fetchCount != null && fetchCount > 0) {
                config.products = [data.nodes?.[0]]; // Safe access
            }
            config.products = addSubscriptionsToProducts(config.products ?? [], data);
            // @ts-expect-error required
            config.discounted_products = addSubscriptionsToProducts(config.discounted_products ?? [], data);
            // @ts-expect-error required
            config.pre_selected_products = addSubscriptionsToProducts(config?.pre_selected_products ?? [], data);
        });

        bundleConfig.forEach((config) => {
            const bundle_type = config?.bundle_type || "";
            if (fetchCount != null && fetchCount > 0) {
                config.products = [data.nodes?.[0]];
            }
            if (config?.bundle_type === BundleTypes.MIX_MATCH_SECTIONAL) {
                // @ts-expect-error hack
                config?.mix_match_sections?.map((section: mix_match_section) => {
                    section.products = updateVariantPrices(section.products ?? [], data, true, bundle_type);
                    // @ts-expect-error required
                    section.offered_products = updateVariantPrices(
                        section.offered_products ?? [],
                        data,
                        false,
                        bundle_type,
                    );
                    // @ts-expect-error required
                    section.discounted_products = updateVariantPrices(
                        section.discounted_products ?? [],
                        data,
                        false,
                        bundle_type,
                    );
                    // @ts-expect-error hack
                    section.free_gifts = updateVariantPrices(section?.free_gifts ?? [], data, false, bundle_type);
                });
                // @ts-expect-error hack
                config.pre_selected_products = updateVariantPrices(
                    config?.pre_selected_products ?? [],
                    data,
                    false,
                    bundle_type,
                );
            } else if (config.bundle_type === BundleTypes.VOLUME_DISCOUNT) {
                config.products = updateVariantPrices(config.products ?? [], data, true, bundle_type);
                (config as VolumeConfigInterface).volume_discounts?.forEach((offer: OfferInterface) => {
                    offer.bundle_products = updateVariantPrices(offer.bundle_products ?? [], data, false, bundle_type);
                    offer.upsell_products = updateVariantPrices(offer.upsell_products ?? [], data, false, bundle_type);
                    offer.free_gifts = updateVariantPrices(offer.free_gifts ?? [], data, false, bundle_type);
                });
            } else {
                config.products = updateVariantPrices(config.products ?? [], data, true, bundle_type);
                // @ts-expect-error required
                config.offered_products = updateVariantPrices(config.offered_products ?? [], data, false, bundle_type);
                // @ts-expect-error required
                config.discounted_products = updateVariantPrices(
                    config.discounted_products ?? [],
                    data,
                    false,
                    bundle_type,
                );
                // @ts-expect-error hack
                config.free_gifts = updateVariantPrices(config?.free_gifts ?? [], data, false, bundle_type);
                if ((config as ProductAddonsConfigInterface)?.variant_addons) {
                    (config as ProductAddonsConfigInterface).variant_addons = Object.fromEntries(
                        // @ts-expect-error required
                        Object.entries(config.variant_addons).map(([variantId, addonProducts]: [string, any]) => [
                            variantId,
                            updateVariantPrices(addonProducts ?? [], data, false, bundle_type),
                        ]),
                    );
                }
            }
        });

        if (standalone) {
            bundleConfig.forEach((config: any) => {
                if (bundleConfig) syncFlatFixedDiscountValues(config);
            });
        }

        window.kefi_bundles.prices_synced = true;
        return bundleConfig;
    } catch (error) {
        console.error("Error fetching products:");
        onFailedCallback();
        return bundleConfig;
    }
};

export const fetchStoreProducts = async (
    storefrontAccessToken: string,
    standalone?: boolean | undefined,
    fetchCount: null | number = 1,
) => {
    const onFailedCallback = () => {
        return [];
    };

    if (!storefrontAccessToken) {
        onFailedCallback();
        return [];
    }

    const context = getStoreContext(standalone);
    // console._log(productIds);

    const query = `
        query getProducts($query: String) ${context} {
            products(first: ${fetchCount}, query: $query) {
                nodes {
                    title
                    handle
                    id
                      images(first: 10) { 
                nodes {
                    id
                    url
                    altText
                }
              }
                    options{
                        id
                        name
                        values
                    }
                    sellingPlanGroups(first: 10) {
                        nodes {
                            sellingPlans(first: 10) {
                                nodes {
                                    id
                                    name
                                    recurringDeliveries
                                    billingPolicy {
                                        __typename
                                        ... on SellingPlanRecurringBillingPolicy {
                                            interval
                                            intervalCount
                                        }
                                    }
                                    deliveryPolicy {
                                        __typename
                                        ... on SellingPlanRecurringDeliveryPolicy {
                                            interval
                                            intervalCount
                                        }
                                    }
                                    priceAdjustments {
                                        adjustmentValue {
                                            ... on SellingPlanFixedAmountPriceAdjustment {
                                                adjustmentAmount {
                                                    amount
                                                }
                                            }
                                            ... on SellingPlanFixedPriceAdjustment {
                                                price {
                                                    amount
                                                }
                                            }
                                            ... on SellingPlanPercentagePriceAdjustment {
                                                adjustmentPercentage
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    variants(first: ${VARIANTS_PAGE_SIZE}) {
                        ${VARIANTS_CONNECTION_FIELDS}
                    }
                }
            }
        }
    `;

    const variables = {
        query: "",
    };

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontAccessToken);
    myHeaders.append("Cookie", "request_method=POST");

    const raw = JSON.stringify({
        query,
        variables,
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        // redirect: "follow",
    };

    try {
        const userShopname = !standalone ? shopify.config.shop : window.kefi_bundles.shop;
        const response = await fetch(`https://${userShopname}/api/2025-07/graphql.json`, requestOptions);
        const result = await response.json();
        if (result?.errors?.length) {
            onFailedCallback();
            return [];
        }
        await fetchRemainingVariants(result.data.products?.nodes ?? [], context, storefrontAccessToken, userShopname);
        const data = result.data.products?.nodes?.map((node: any) => ({
            handle: node?.handle,
            id: node?.id,
            title: node?.title,
            images:
                node.images?.nodes?.map((image: any) => ({
                    id: image.id,
                    originalSrc: image.url,
                    altText: image.altText || "",
                })) || [],
        }));
        const dataWithSubscriptions = addSubscriptionsToProducts(data, result.data.products);
        const updateData = updateVariantPrices(dataWithSubscriptions, result.data.products, true);
        return updateData;
    } catch (error) {
        console.error("Error fetching products:", error);
        onFailedCallback();
        return [];
    }
};

export const fetchStoreProductsWithMetaField = async (
    storefrontAccessToken: string,
    standalone?: boolean | undefined,
    currentProductId: string = "",
    fetchCount: null | number = 10, // fetch count
) => {
    const onFailedCallback = () => {
        return [];
    };

    if (!storefrontAccessToken) {
        onFailedCallback();
        return [];
    }

    const context = getStoreContext(standalone);
    // console._log(productIds);

    const query = `
        query getProducts($query: String) ${context} {
            products(first: ${fetchCount}, query: $query) {
                nodes {
                    title
                    handle
                    id
                    options{
                        id
                        name
                        values
                    }
                    featuredImage {
                      url
                    }
                     metafield(namespace: "kefi_swatches", key: "swatches") {
                        value
                        type
                    }
                    variants(first: ${VARIANTS_PAGE_SIZE}) {
                        ${VARIANTS_CONNECTION_FIELDS}
                    }
                }
            }
        }
    `;

    const queryById = `
    query getProductById($id: ID!) ${context} {
      node(id: $id) {
        ... on Product {
          title
          handle
          id
          options {
            id
            name
            values
          }
          featuredImage { url }
          metafield(namespace: "kefi_swatches", key: "swatches") {
            value
            type
          }
          variants(first: ${VARIANTS_PAGE_SIZE}) {
            ${VARIANTS_CONNECTION_FIELDS}
          }
        }
      }
    }
  `;

    const selectedQuery = currentProductId ? queryById : query;

    const variables = currentProductId ? { id: currentProductId } : { query: "" };

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontAccessToken);
    myHeaders.append("Cookie", "request_method=POST");

    const raw = JSON.stringify({
        query: selectedQuery,
        variables,
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        // redirect: "follow",
    };

    try {
        const userShopname = !standalone ? shopify.config.shop : window.kefi_bundles.shop;
        const response = await fetch(`https://${userShopname}/api/2025-07/graphql.json`, requestOptions);
        const result = await response.json();
        if (result?.errors?.length) {
            onFailedCallback();
            return [];
        }

        await fetchRemainingVariants(
            currentProductId ? [result.data?.node] : (result.data.products?.nodes ?? []),
            context,
            storefrontAccessToken,
            userShopname,
        );

        let products: any[] = [];

        if (currentProductId) {
            const node = result.data?.node;
            if (!node) return [];

            const formattedProduct = {
                handle: node?.handle,
                id: node?.id,
                title: node?.title,
                metafield: node?.metafield,
                options: node?.options,
                images: [{ originalSrc: node?.featuredImage?.url }],
                variants: node.variants.nodes.map((variant: any) => {
                    if (node.variants.nodes.length === 1) {
                        variant.title = node.title;
                    }
                    return {
                        ...variant,
                        image: { originalSrc: variant?.image?.url },
                    };
                }),
            };

            products = [formattedProduct];
        } else {
            const data = result.data.products?.nodes?.map((node: any) => ({
                handle: node?.handle,
                id: node?.id,
                title: node?.title,
                metafield: node?.metafield,
                options: node?.options,
                images: [{ originalSrc: node?.featuredImage?.url }],
                variants: node.variants.nodes.map((variant: any) => {
                    if (node.variants.nodes.length === 1) {
                        variant.title = node.title;
                    }
                    return {
                        ...variant,
                        image: { originalSrc: variant?.image?.url },
                    };
                }),
            }));

            const allProducts = data || [];
            let validProduct: any = null;

            for (const node of allProducts) {
                if (node.options?.length > 1) {
                    validProduct = node;
                    break;
                }
            }

            if (!validProduct && allProducts.length) {
                validProduct = allProducts[0];
            }

            products = [validProduct];
        }

        return products;
    } catch (error) {
        console.error("Error fetching products:", error);
        onFailedCallback();
        return [];
    }
};

export const fetchProductsWithCursor = async (
    storefrontToken: string,
    afterCursor: string | null = null,
    fetchCount: number = 20,
    searchTerm: string,
    standalone?: boolean,
) => {
    const emptyResult = { products: [], pageInfo: { endCursor: null, hasNextPage: false } };

    if (!storefrontToken) {
        return emptyResult;
    }

    const context = getStoreContext(standalone);

    const userShopname = !standalone ? shopify.config.shop : window.kefi_bundles.shop;

    const query = `
query getProducts($first: Int!, $after: String, $query: String) ${context} {
  products(first: $first, after: $after, query: $query) {
    nodes {
      id
      title
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
`;

    const variables = {
        first: fetchCount,
        after: afterCursor,
        query: searchTerm ? `${searchTerm}` : "",
    };

    const headers = new Headers({
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontToken,
        Cookie: "request_method=POST",
    });

    const requestOptions = {
        method: "POST",
        headers,
        body: JSON.stringify({ query, variables }),
    };

    try {
        const response = await fetch(`https://${userShopname}/api/2025-07/graphql.json`, requestOptions);
        const result = await response.json();

        if (result?.errors?.length) {
            return emptyResult;
        }

        const nodes = result.data.products?.nodes ?? [];
        const products: {
            id: string;
            title: string;
        }[] = nodes.map((node: any) => ({
            id: node.id,
            title: node.title,
        }));

        const pageInfo = result.data.products?.pageInfo;
        const nextCursor: FetchProductsResult["nextCursor"] = pageInfo?.hasNextPage ? pageInfo.endCursor : null;
        typeof nextCursor;
        return { products, pageInfo };
    } catch (error) {
        console.error("Error fetching products:", error);
        return emptyResult;
    }
};

export const fetchCollectionProducts = async (
    collectionId: string,
    storefrontAccessToken: string,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>, // added loading state
    standalone?: boolean | undefined,
    fetchCount: number = 5, // fetch count
    afterCursor: string | null = null, // for pagination
    signal?: AbortSignal,
) => {
    setLoading(true); // start loader
    const context = getStoreContext(standalone);

    const query = `
    query CollectionProducts ${context}{
      collection(id: "gid://shopify/Collection/${collectionId}") {
        handle
        id
        products(first: ${fetchCount}${afterCursor ? `, after: "${afterCursor}"` : ""}) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            cursor
            node {
              id
              title
              description
              descriptionHtml
              handle 
              tags
              images(first: 10) { 
                nodes {
                    id
                    url
                    altText
                }
              }
              media(first: 50) {
                edges {
                  node {
                    mediaContentType
                    alt
                    ... on MediaImage {
                      image {
                        url
                        altText
                      }
                    }
                    ... on Model3d {
                      sources {
                        url
                        mimeType
                        format
                        filesize
                      }
                    }
                    ... on Video {
                      sources {
                        url
                        mimeType
                        format
                        height
                        width
                      }
                    }
                    ... on ExternalVideo {
                      embeddedUrl
                    }
                  }
                }
              }
              options {
                id
                name
                values
              }
            metafield(namespace: "kefi_swatches", key: "swatches") {
                value
                type
           }
            metafield2:metafield(namespace: "custom", key: "product_weight") {
                value
                type
           }
            metafield3:metafield(namespace: "custom",key: "pre_order_expected_dispatch_mid_april") {
                value
            }
            metafield4:metafield(namespace: "custom",key: "custom_text") {
                value
            }
            metafield5:metafield(namespace: "custom",key: "product_description") {
                value
            }
            metafield6:metafield(namespace: "custom",key: "weekly_dosage") {
                value
            }
            sellingPlanGroups(first: 10) {
                nodes {
                  sellingPlans(first: 10) {
                    nodes {
                      id
                      name
                      recurringDeliveries
                      billingPolicy {
                          __typename
                          ... on SellingPlanRecurringBillingPolicy {
                              interval
                              intervalCount
                          }
                      }
                      deliveryPolicy {
                          __typename
                          ... on SellingPlanRecurringDeliveryPolicy {
                              interval
                              intervalCount
                          }
                      }
                      priceAdjustments {
                        adjustmentValue {
                          ... on SellingPlanFixedAmountPriceAdjustment {
                            adjustmentAmount {
                              amount
                            }
                          }
                          ... on SellingPlanFixedPriceAdjustment {
                            price {
                              amount
                            }
                          }
                          ... on SellingPlanPercentagePriceAdjustment {
                            adjustmentPercentage
                          }
                        }
                      }
                    }
                  }
                }
              }
              variants(first: ${VARIANTS_PAGE_SIZE}) {
                ${VARIANTS_CONNECTION_FIELDS}
              }
            }
          }
        }
      }
    }
  `;

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontAccessToken);

    const raw = JSON.stringify({ query });

    try {
        const userShopname = !standalone ? shopify.config.shop : window.kefi_bundles.shop;
        const response = await fetch(`https://${userShopname}/api/2025-07/graphql.json`, {
            method: "POST",
            headers: myHeaders,
            body: raw,
            signal,
        });
        const result = await response.json();

        const edges = result?.data?.collection?.products?.edges || [];
        const pageInfo = result?.data?.collection?.products?.pageInfo;

        await fetchRemainingVariants(
            edges.map((edge: any) => edge?.node),
            context,
            storefrontAccessToken,
            userShopname,
            signal,
        );

        const products = formatProducts(edges);
        window.kefi_bundles.prices_synced = true;
        return { products, pageInfo };
    } catch (err) {
        console.error("Error fetching collection products:", err);
        return { products: [], pageInfo: { hasNextPage: false, endCursor: null } };
    } finally {
        setLoading(false); // stop loader
    }
};

export const fetchProductChunksWithOptionsMeta = async (
    storefrontAccessToken: string,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    cursor: string | null = null,
    standalone?: boolean,
    fetchCount: number = 250,
) => {
    setLoading(true);

    if (!storefrontAccessToken) return { products: [], hasNextPage: false, endCursor: null };

    const context = getStoreContext(standalone);

    const afterClause = cursor ? `, after: "${cursor}"` : "";

    const query = `
    query getProducts($query: String) ${context} {
      products(first: ${fetchCount}${afterClause}, query: $query) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          title
          options {
            id
            name
            values
          }
          metafield(namespace: "kefi_swatches", key: "swatches") {
            value
            type
          }
        }
      }
    }
  `;

    const variables = {
        query: "",
    };

    const headers = new Headers({
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
    });

    try {
        const shop = standalone ? window.kefi_bundles.shop : shopify.config.shop;

        const res = await fetch(`https://${shop}/api/2025-07/graphql.json`, {
            method: "POST",
            headers,
            body: JSON.stringify({ query, variables }),
        });

        const json = await res.json();

        const products =
            json?.data?.products?.nodes?.map((node: any) => ({
                id: node.id,
                title: node.title,
                options: node.options,
                metafield: node.metafield,
            })) || [];

        const pageInfo = json?.data?.products?.pageInfo;

        return {
            products,
            hasNextPage: pageInfo?.hasNextPage || false,
            endCursor: pageInfo?.endCursor || null,
        };
    } catch (err) {
        console.error("fetchProductChunksWithOptionsMeta error:", err);
        return { products: [], hasNextPage: false, endCursor: null };
    } finally {
        setLoading(false);
    }
};

export const fetchProductWithSwatchesTag = async (
    storefrontAccessToken: string,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    cursor: string | null = null,
    standalone?: boolean,
    fetchCount: number = 250,
) => {
    setLoading(true);

    if (!storefrontAccessToken) return { products: [], hasNextPage: false, endCursor: null };

    const context = getStoreContext(standalone);

    const afterClause = cursor ? `, after: "${cursor}"` : "";

    const query = `
  query getProducts($query: String) ${context} {
    products(first: ${fetchCount}, sortKey: UPDATED_AT, reverse: true${afterClause}, query: $query) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        title
        options {
          id
          name
          values
        }
        metafield(namespace: "kefi_swatches", key: "swatches") {
          value
          type
        }
      }
    }
  }
`;

    const variables = {
        query: "tag:kefi_swatches",
    };

    const headers = new Headers({
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
    });

    try {
        const shop = standalone ? window.kefi_bundles.shop : shopify.config.shop;

        const res = await fetch(`https://${shop}/api/2025-07/graphql.json`, {
            method: "POST",
            headers,
            body: JSON.stringify({ query, variables }),
        });

        const json = await res.json();

        const products =
            json?.data?.products?.nodes?.map((node: any) => ({
                id: node.id,
                title: node.title,
                options: node.options,
                metafield: node.metafield,
            })) || [];

        const pageInfo = json?.data?.products?.pageInfo;

        return {
            products,
            hasNextPage: pageInfo?.hasNextPage || false,
            endCursor: pageInfo?.endCursor || null,
        };
    } catch (err) {
        console.error("fetchProductChunksWithOptionsMeta error:", err);
        return { products: [], hasNextPage: false, endCursor: null };
    } finally {
        setLoading(false);
    }
};

export const fetchCollectionProductChunksWithOptionsMeta = async (
    collectionId: string,
    storefrontAccessToken: string,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    standalone?: boolean,
    afterCursor: string | null = null,
    fetchCount: number = 250,
): Promise<{
    products: ProductWithOptionsAndMeta[];
    nextCursor: string | null;
    hasNext: boolean;
}> => {
    setLoading(true);

    const context = getStoreContext(standalone);

    const query = `
    query CollectionProducts ${context}{
      collection(id: "${collectionId}") {
        handle
        id
        products(first: ${fetchCount}${afterCursor ? `, after: "${afterCursor}"` : ""}) {
          pageInfo {
            hasNextPage
            endCursor
          }
           edges {
                node {
                    id
                    title
                    options {
                        id
                        name
                        values
                    }
                    metafield(namespace: "kefi_swatches", key: "swatches") {
                                value
                                type
                    } 
                }
            }
        }
      }
    }
  `;

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontAccessToken);

    const raw = JSON.stringify({ query });

    try {
        const userShopname = !standalone ? shopify.config.shop : window.kefi_bundles.shop;
        const response = await fetch(`https://${userShopname}/api/2025-07/graphql.json`, {
            method: "POST",
            headers: myHeaders,
            body: raw,
        });

        const result = await response.json();

        const edges = result?.data?.collection?.products?.edges || [];
        const pageInfo = result?.data?.collection?.products?.pageInfo;

        const products: ProductWithOptionsAndMeta[] = edges.map(({ node }: any) => ({
            id: node.id,
            title: node.title,
            options: node.options,
            metafield: node.metafield,
        }));

        return {
            products,
            nextCursor: pageInfo?.endCursor ?? null,
            hasNext: pageInfo?.hasNextPage ?? false,
        };
    } catch (err) {
        console.error("Error fetching collection products:", err);
        return {
            products: [],
            nextCursor: null,
            hasNext: false,
        };
    } finally {
        setLoading(false);
    }
};

const formatProducts = (edges: any) => {
    return edges.map((edge: any) => {
        const node = edge.node;
        const sellingPlans =
            node.sellingPlanGroups?.nodes?.flatMap(
                (group: any) =>
                    group.sellingPlans?.nodes?.map((plan: any) => ({
                        id: plan.id,
                        name: plan.name,
                        priceAdjustments: plan.priceAdjustments || [],
                    })) || [],
            ) || [];

        return {
            // Destructure and format the data
            id: node.id,
            images:
                node.images?.nodes?.map((image: any) => ({
                    id: image.id,
                    originalSrc: image.url,
                    altText: image.altText || "",
                })) || [],
            media: node.media?.edges?.map((edge: any) => edge.node) || [],
            title: node?.title || "",
            handle: node?.handle || "",
            quantity: 1, // Default value
            maxProductStock: 0, // Default value
            selectedVariants: [], // Default value
            subscriptions: sellingPlans,
            oneTimePurchase: true, // Default value
            isSubscribed: false, // Default value
            options: node?.options || [], // Formatted options
            metafield: node?.metafield || null, // Formatted metafield
            metafield2: node?.metafield2 || null, // Formatted metafield
            metafield3: node?.metafield3 || null,
            metafield4: node?.metafield4 || null,
            metafield5: node?.metafield5 || null,
            metafield6: node?.metafield6 || null,
            tags: node?.tags || [],
            description: node?.description,
            descriptionHtml: node?.descriptionHtml,
            variants:
                node.variants?.nodes?.map((variant: any) => ({
                    price: variant.price.amount,
                    required_product: false, // Default value
                    compareAtPrice:
                        variant?.compareAtPrice?.amount && variant.compareAtPrice.amount >= variant.price.amount
                            ? variant.compareAtPrice.amount
                            : variant.price.amount,
                    get displayName() {
                        return this.title;
                    },
                    id: variant.id,
                    selectedOptions: variant.selectedOptions,
                    title: variant?.title?.toLowerCase() === "default title" ? node?.title : variant?.title,
                    image: { originalSrc: variant?.image?.url },
                    quantityAvailable: variant.quantityAvailable,
                    availableForSale: variant.availableForSale,
                    metafield: variant?.metafield,
                    sku: variant?.sku,
                    capacityValue: getCapacityValue(variant?.capacityValues?.value),
                    sellingPlanIds:
                        variant?.sellingPlanAllocations?.nodes?.map((node: any) => node.sellingPlan.id) || [],
                })) || [], // Formatted variants
        };
    });
};

// Shopify caps a connection page at 250, while a product can have up to 2048 variants
export const VARIANTS_PAGE_SIZE = 250;

export const VARIANTS_CONNECTION_FIELDS = `
    pageInfo {
        hasNextPage
        endCursor
    }
    nodes {
        id
        metafield(namespace: "custom", key: "shade_image") {
            value
        }
        capacityValues: metafield(namespace: "custom", key: "capacity_values") {
            value
        }
        weight
        weightUnit
        quantityAvailable
        availableForSale
        price {
            amount
            currencyCode
        }
        compareAtPrice {
            amount
        }
        title
        image {
            url
        }
        selectedOptions {
            name
            value
        }
        sku
        sellingPlanAllocations(first: 10) {
            nodes {
                sellingPlan {
                    id
                }
            }
        }
    }
`;

// Appends the variants past the first page onto each product node, in place
export const fetchRemainingVariants = async (
    productNodes: any[],
    context: string,
    storefrontAccessToken: string,
    userShopname: string | undefined,
    signal?: AbortSignal,
) => {
    const query = `
        query getProductVariants($id: ID!, $after: String) ${context} {
            product(id: $id) {
                variants(first: ${VARIANTS_PAGE_SIZE}, after: $after) {
                    ${VARIANTS_CONNECTION_FIELDS}
                }
            }
        }
    `;

    await Promise.all(
        productNodes
            .filter((node) => node?.variants?.pageInfo?.hasNextPage)
            .map(async (node) => {
                let pageInfo = node.variants.pageInfo;

                while (pageInfo?.hasNextPage) {
                    const response = await fetch(`https://${userShopname}/api/2025-07/graphql.json`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
                        },
                        body: JSON.stringify({ query, variables: { id: node.id, after: pageInfo.endCursor } }),
                        signal,
                    });
                    const result = await response.json();
                    const variants = result?.data?.product?.variants;

                    if (result?.errors?.length || !variants) {
                        console.error("Error fetching remaining variants:", result?.errors);
                        return;
                    }

                    node.variants.nodes.push(...variants.nodes);
                    pageInfo = variants.pageInfo;
                }
            }),
    );
};

export const getProductsDynamicallyAndReturnNewProductsArray = async (
    productsList: any[],
    storefrontAccessToken: string,
    standalone?: boolean,
    bundle_type: string = "",
) => {
    if (!storefrontAccessToken) {
        productsList.forEach((product) => {
            product.variants.forEach((v: any) => {
                v.availableForSale = true;
                v.quantityAvailable = 1000;
            });
        });

        return productsList;
    }

    const productIds = productsList.reduce((acc: any[], product: any) => {
        if (product.id && typeof product.id === "string") {
            acc.push(product.id.split("/").pop());
        }
        return acc;
    }, []);

    const productQuery = productIds.map((id: any) => `id:${id}`).join(" OR ");
    const context = getStoreContext(standalone);

    const query = `
        query getProducts($query: String) ${context} {
            products(first: 250, query: $query) {
                nodes {
                title
                id
                variantsCount {
                    count
                    precision
                }
                options{
                    id
                    name
                    values
                }
                 metafield(namespace: "kefi_swatches", key: "swatches") {
                        value
                        type
                 }
                images(first: 10) { 
                    nodes {
                        id
                        url
                        altText
                    }
                }
                media(first: 50) {
                  edges {
                    node {
                      mediaContentType
                      alt
                      ... on MediaImage {
                        image {
                          url
                          altText
                        }
                      }
                      ... on Model3d {
                        sources {
                          url
                          mimeType
                          format
                          filesize
                        }
                      }
                      ... on Video {
                        sources {
                          url
                          mimeType
                          format
                          height
                          width
                        }
                      }
                      ... on ExternalVideo {
                        embeddedUrl
                      }
                    }
                  }
                }
                sellingPlanGroups(first: 10) {
                    nodes {
                    sellingPlans(first: 10) {
                        nodes {
                        id
                        name
                        recurringDeliveries
                        billingPolicy {
                            __typename
                            ... on SellingPlanRecurringBillingPolicy {
                                interval
                                intervalCount
                            }
                        }
                        deliveryPolicy {
                            __typename
                            ... on SellingPlanRecurringDeliveryPolicy {
                                interval
                                intervalCount
                            }
                        }
                        priceAdjustments {
                            adjustmentValue {
                            ... on SellingPlanFixedAmountPriceAdjustment {
                                adjustmentAmount {
                                amount
                                }
                            }
                            ... on SellingPlanFixedPriceAdjustment {
                                price {
                                amount
                                }
                            }
                            ... on SellingPlanPercentagePriceAdjustment {
                                adjustmentPercentage
                            }
                            }
                        }
                        }
                    }
                    }
                }
                variants(first: ${VARIANTS_PAGE_SIZE}) {
                    ${VARIANTS_CONNECTION_FIELDS}
                }
                collections(first: 50){
                    nodes {
                        id
                    }
                }
                }
            }
        }
    `;

    const variables = {
        query: productQuery,
    };

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontAccessToken);
    myHeaders.append("Cookie", "request_method=POST");

    const raw = JSON.stringify({
        query,
        variables,
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        // redirect: "follow",
    };

    try {
        const userShopname = !standalone ? shopify.config.shop : window.kefi_bundles.shop;
        const response = await fetch(`https://${userShopname}/api/2025-07/graphql.json`, requestOptions);
        const result = await response.json();

        if (result?.errors?.length) {
            return productsList;
        }
        const data = result.data.products;

        await fetchRemainingVariants(data.nodes, context, storefrontAccessToken, userShopname);

        const finalData = addSubscriptionsToProducts(productsList, data);

        const newProductsList = updateVariantPrices(finalData, data, false, bundle_type);

        return newProductsList;
    } catch (error) {
        console.error("Error fetching products:", error);
        return productsList;
    }
};

export const getDiscountValueWithSign = (
    type: DiscountTypes | "" = "",
    value = 0,
    currency = "",
    money_format = "",
    footer_text?: string,
    free_text?: string,
) => {
    let format = "";

    value = Number(value);
    switch (type) {
        case "percentage":
            if (value === 0) {
                format = "";
            } else {
                format =
                    value === 100 ? free_text || "Free" : `${Math.round(value * 100) / 100}% ${footer_text || "Off"}`;
            }
            break;
        case "flat":
            if (value === 0) {
                return <></>;
            }
            // const pLabel = getPriceLabel(value, money_format, currency);
            return (
                <span>
                    {getPriceLabel(value, money_format, currency)} {footer_text || "Off"}
                </span>
            );
            break;
        case "fixed":
            // format = `Flat ${getPriceLabel(value, money_format, currency)}`;
            return <span>@ {getPriceLabel(value, money_format, currency)}</span>;
            break;
        default:
            format = "";
    }

    return format;
};

export const getDiscountValueWithSignString = (
    type: DiscountTypes | "" = "",
    value = 0,
    currency = "",
    money_format = "",
    footer_text?: string,
    free_text?: string,
): string => {
    let format = "";

    value = Number(value);
    switch (type) {
        case "percentage":
            if (value === 0) {
                format = "";
            } else {
                format = value === 100 ? free_text || "Free" : `${Math.round(value * 100) / 100}%`;
            }
            break;

        case "flat":
            if (value === 0) {
                format = "";
            } else {
                format = `${getPriceLabel(value, money_format, currency, true, "string")} ${footer_text || "Off"}`;
            }
            break;

        case "fixed":
            format = `${getPriceLabel(value, money_format, currency, true, "string")}`;
            break;

        default:
            format = "";
    }

    return format;
};

export const getDiscountValueWithSignStringSubscription = (
    type: DiscountTypes | "" = "",
    value = 0,
    currency = "",
    money_format = "",
    free_text?: string,
): string => {
    let format = "";

    value = Number(value);
    switch (type) {
        case "percentage":
            if (value === 0) {
                format = "";
            } else {
                format = value === 100 ? (free_text ?? "Free") : `${Math.round(value * 100) / 100}%`;
            }
            break;

        case "flat":
            if (value === 0) {
                format = "";
            } else {
                format = `${getPriceLabel(value, money_format, currency, true, "string")}`;
            }
            break;

        case "fixed":
            format = `${getPriceLabel(value, money_format, currency, true, "string")}`;
            break;

        default:
            format = "";
    }

    return format;
};

export const getFinalPrice = (
    type: DiscountTypes | "" = "",
    value = 0,
    actualPrice: number,
    addOnPrice: number = 0,
): number => {
    let finalPrice = actualPrice;

    switch (type) {
        case "percentage":
            // Calculate discount and truncate to 2 decimals
            const discount = (actualPrice * value) / 100;
            const truncatedDiscount = Math.trunc(discount * 100) / 100;
            finalPrice = actualPrice - truncatedDiscount;
            break;
        case "flat":
            finalPrice = actualPrice - value;
            break;
        case "fixed":
            finalPrice = value * 1.0;
            break;
        default:
            finalPrice = actualPrice;
    }
    finalPrice = finalPrice + addOnPrice;
    return Math.round(finalPrice * 100) / 100;
};

export const handleBundleUniqueName = (val = "", prevNamesArr: string[] = []) => {
    if (val.length && prevNamesArr.length && prevNamesArr.includes(val.toLowerCase())) {
        return "Name must be unique";
    }
};

type NestedObject = {
    [key: string]: any;
};

export const updateNestedStructure = (nestedObj: any, flatObj: any): typeof nestedObj => {
    const updatedObj: NestedObject = Array.isArray(nestedObj) ? [] : {};

    for (const key in nestedObj) {
        if (nestedObj[key] !== null && typeof nestedObj[key] === "object" && !Array.isArray(nestedObj[key])) {
            // Recursively update nested objects
            updatedObj[key] = updateNestedStructure(nestedObj[key], flatObj);
        } else if (Object.prototype.hasOwnProperty.call(flatObj, key)) {
            // Update the value from the flat object
            updatedObj[key] = flatObj[key];
        } else {
            // Keep the original value if the flat object doesn't have the key
            updatedObj[key] = nestedObj[key];
        }
    }

    return updatedObj;
};

export const getPriceLabel = (
    amount: number | string,
    money_format: string,
    currency: string,
    useConversion: boolean = true,
    returnType: "string" | "" = "",
) => {
    try {
        if (isSpiritEmbassyShop() && window.Shopify.country == "GB") amount = priceWithVat(+amount, 20);

        const rate = !useConversion || window.kefi_bundles.prices_synced ? 1 : window.kefi_bundles.localization.rate;

        let locale = getUserLocale();
        if (window?.kefi_bundles?.shop == "extnutpro.myshopify.com") {
            locale = "en";
        }

        const noDecimalFormats = [
            "amount_no_decimals",
            "amount_no_decimals_with_comma_separator",
            "amount_no_decimals_with_space_separator",
        ];

        const noDecimalCurrencies = ["JPY", "KRW", "VND", "IDR", "ISK", "CLP", "MGA", "UGX", "PYG"];

        const isNoDecimalFormat = noDecimalFormats.some((format) => money_format.includes(format));
        const isNoDecimalCurrency = noDecimalCurrencies.includes(currency);

        let finalAmount: number = Math.round(+amount * rate * 100) / 100;

        let minimumFractionDigits = 2;

        if (isNoDecimalFormat || isNoDecimalCurrency) {
            finalAmount = Math.round(+amount * rate);
            minimumFractionDigits = 0;
        }

        const convertedAmount = Intl.NumberFormat(locale, { minimumFractionDigits: minimumFractionDigits }).format(
            finalAmount,
        );

        if (money_format.trim().startsWith("{{") && money_format.trim().endsWith("}}")) {
            return convertedAmount + " " + currency;
        }
        const formatted = money_format.replace(/\{\{.*?\}\}/g, `${convertedAmount}`);

        if (returnType === "string") {
            return formatted;
        }

        return <span dangerouslySetInnerHTML={{ __html: formatted }}></span>;
    } catch (error) {
        console._log(error);
    }
};

export const renderBundleErrorMessage = (msg: string = "", bundleFormId: string, customStyles?: any) => {
    const ele = document.getElementById("kefi_" + bundleFormId);
    let container = document.getElementById("error-message-container-" + bundleFormId);

    if (!container) {
        container = document.createElement("div");
        container.id = "error-message-container-" + bundleFormId;
        ele?.parentNode?.insertBefore(container, ele.nextSibling);
    }

    container.textContent = msg;

    // Default styles
    const defaultStyles = {
        color: "red",
        fontSize: "15px",
        fontWeight: "500",
    };

    // Merge custom styles (if any) with defaults
    const finalStyles = { ...defaultStyles, ...customStyles };

    Object.entries(finalStyles).forEach(([key, value]) => {
        if (value) {
            (container!.style as any)[key] = value;
        }
    });
};

export const PRESET_ICON_COMPONENTS: Record<string, IconType> = {
    checkmark: FaCheck,
    dot: MdFiberManualRecord,
    arrow: FaArrowRight,
    star: MdStar,
    heart: MdFavorite,
    thumbs_up: MdThumbUp,
};

export const parseCTAWithIcon = (
    text: string,
    iconUrl?: string,
    size = 28,
    iconType: string = "custom",
    allowHtml = false,
) => {
    const parts = text.split(/{icon}/gi);
    const result: (string | JSX.Element)[] = [];
    const PresetIcon = PRESET_ICON_COMPONENTS[iconType];

    parts?.forEach((part, index) => {
        result.push(allowHtml ? <span key={`text-${index}`} dangerouslySetInnerHTML={{ __html: part }} /> : part);
        if (index < parts.length - 1) {
            if (iconType === "custom" && iconUrl) {
                result.push(
                    <img
                        key={`icon-${index}`}
                        src={iconUrl}
                        alt="icon"
                        style={{ height: size, width: "auto", margin: "0 8px", verticalAlign: "middle" }}
                    />,
                );
            } else if (iconType !== "none" && iconType !== "custom" && PresetIcon) {
                result.push(
                    <PresetIcon
                        key={`icon-${index}`}
                        size={size}
                        style={{ margin: "0 8px", verticalAlign: "middle" }}
                    />,
                );
            }
        }
    });
    return result;
};

export const getUserLocale = (): string => {
    let locale;
    if (window.isKefiAdmin) {
        locale = window.shopify.config.locale;
    } else {
        locale = window.kefi_bundles.localization.locale;

        if (!locale.includes("-")) {
            locale = locale + `-${window.kefi_bundles.localization.country}`;
        }
    }

    return locale || "en-US"; // default to en-US if no locale is found
};
export const updateShowImage = (productImgShow: string | undefined, isMobile: boolean) => {
    switch (productImgShow) {
        case "none":
            return false;
        case "all":
            return true;
        case "desktop":
            return !isMobile;
        default:
            return true;
    }
};

export const getPixelsForImage = (val: string | undefined, returnType: "string" | "number" = "string") => {
    let size: string | number = 70;
    switch (val) {
        case "small":
            size = 50;
            break;
        case "medium":
            size = 60;
            break;
        case "large":
            size = 70;
            break;
        case "fbt_small":
            size = 130;
            break;
        case "fbt_medium":
            size = 150;
            break;
        case "fbt_large":
            size = 160;
            break;
        case "bb_small":
            size = 130;
            break;
        case "bb_medium":
            size = 150;
            break;
        case "bb_large":
            size = 160;
            break;
        case "placeholder_small":
            size = 60;
            break;
        case "placeholder_medium":
            size = 80;
            break;
        case "placeholder_large":
            size = 100;
            break;
        default:
            size = 70;
    }
    if (returnType == "string") {
        size = size + "px";
    }

    return size;
};

export const getPixelsForCart = (val: string | undefined, returnType: "string" | "number" = "string") => {
    let size: string | number = 70;
    switch (val) {
        case HEADER_HEIGHT_OPT.SMALL:
            size = IS_METAL_BIRD_SHOP ? 30 : 50;
            break;
        case HEADER_HEIGHT_OPT.MEDIUM:
            size = 60;
            break;
        case HEADER_HEIGHT_OPT.LARGE:
            size = 70;
            break;
        case CART_WIDTH_OPT.COMPACT:
            // size = 350;
            size = 400;
            break;
        case CART_WIDTH_OPT.STANDARD:
            size = 400;
            break;
        case CART_WIDTH_OPT.EXPANDED:
            size = 450;
            break;
        // admin panel width
        case CART_WIDTH_OPT.COMPACT + "-admin":
            size = 410;
            break;
        case CART_WIDTH_OPT.STANDARD + "-admin":
            size = 510;
            break;
        case CART_WIDTH_OPT.EXPANDED + "-admin":
            size = 625;
            break;
    }
    if (returnType == "string") {
        size = size + "px";
    }

    return size;
};

export const validateDiscountValue = (value: string | number, discountType: string): string | undefined => {
    if (discountType === "none") {
        return "";
    }

    const discountValue = +value;

    if (discountType === "percentage" && discountValue > 100) {
        return "Invalid discount";
    }

    if (discountValue <= 0) {
        return "Invalid discount";
    }

    return undefined;
};

export const validateDiscountOptions = (discountOptions: MixMatchOption[]): string => {
    if (!discountOptions || discountOptions.length === 0) {
        return "No discount options provided.";
    }

    let previousMax = 0;

    for (let i = 0; i < discountOptions.length; i++) {
        const option = discountOptions[i];

        // Check if quantity is a number and greater than zero
        if (isNaN(option.quantity) || option.quantity <= 0) {
            return `Quantity must be a number greater than 0, in Discount option ${i + 1}.`;
        }

        // Check if maxQuantity is a number and greater than or equal to quantity
        if (isNaN(option.maxQuantity)) {
            return `Max quantity must be a number, in Discount option ${i + 1}.`;
        } else if (option.maxQuantity < option.quantity) {
            return `Max quantity must be greater than or equal to quantity, in Discount option ${i + 1}.`;
        }

        // Check if discountValue is a number and greater than zero
        if (isNaN(option.discountValue) || option.discountValue < 0) {
            return `Discount value must be a number greater than equal to 0, in Discount option ${i + 1}.`;
        }

        // Check if discountType is provided
        if (!option.discountType) {
            return `Discount type is required in Discount option ${i + 1}.`;
        }

        if (option.addRange) {
            if (previousMax >= option.quantity) {
                return `Quantity ${
                    option.quantity
                } overlaps with the previous range ending at ${previousMax}, in Discount option ${i + 1}.`;
            }
            previousMax = option.maxQuantity;
        } else {
            if (previousMax >= option.quantity) {
                return `Quantity ${
                    option.quantity
                } overlaps with the previous offer ending at ${previousMax}, in Discount option ${i + 1}.`;
            }
            previousMax = option.quantity;
        }
        if (option.allow_free_gifts && (!option.free_gifts || option.free_gifts.length === 0)) {
            return "Free gift product is required";
        }
    }

    return ""; // No errors found
};

export const validateDiscountOptionsBuyN = (discountOptions: BuyNOptions[]): string => {
    if (!discountOptions || discountOptions.length === 0) {
        return "No discount options provided.";
    }

    const requiredItemCounts = discountOptions.map((option) => option.required_item_count);

    const duplicateCountIndex = requiredItemCounts.findIndex(
        (count: number, i: number) => requiredItemCounts.indexOf(count) !== i,
    );
    if (duplicateCountIndex !== -1) {
        return "Required item count must be unique across all options.";
    }

    for (let i = 0; i < discountOptions.length; i++) {
        const option = discountOptions[i];

        if (option.discounted_item_count > option.required_item_count) {
            return `Discounted item count for option ${i + 1} cannot be greater than the required item count.`;
        }
    }

    return ""; // No errors found
};

export const validateBBTierDiscounts = (
    options: BBTierOptions[],
    setError: any = null,
    tier_discount_basis: string,
): string => {
    if (!options || options.length === 0) {
        return "No discount options provided.";
    }
    let error = "";
    const updatedErrors: any = [];
    options.forEach((option, i) => {
        updatedErrors.push({ discountValue: "", quantity: "", selected_products: "" });
        // Validate discountValue
        if (typeof option.discountValue !== "number" || isNaN(option.discountValue)) {
            error = `Tier ${i + 1}: Discount value must be a number.`;
            if (setError != null) {
                updatedErrors[i].discountValue = error;
            } else {
                return error;
            }
        } else if (option.discountValue < 0) {
            error = `Tier ${i + 1}: Discount value must be greater than or equal to 0.`;
            if (setError != null) {
                updatedErrors[i].discountValue = `Min: 0`;
            } else {
                return error;
            }
        }
        // Check for percentage-specific validation
        if (option.discountType === "percentage" && option.discountValue > 100) {
            error = `Tier ${i + 1}: max 100, discount value in option`;
            if (setError != null) {
                updatedErrors[i].discountValue = "Max: 100";
            } else {
                return error;
            }
        }

        if (tier_discount_basis === "product_based") {
            if (!option.selected_products || option.selected_products.length === 0) {
                error = `Group ${i + 1}: At least one product must be selected.`;
                if (setError != null) {
                    updatedErrors[i].selected_products = "Required";
                } else {
                    return error;
                }
            }
        } else {
            // Validate quantity against the previous option
            if (i > 0) {
                const previousOpt = options?.[i - 1];
                if (previousOpt && option.quantity <= previousOpt.quantity) {
                    error = `Tier ${i + 1}: Minimum quantity must be greater than the previous tier's quantity.`;
                    if (setError != null) {
                        updatedErrors[i].quantity = `Min: ${previousOpt?.quantity + 1}`;
                    } else {
                        return error;
                    }
                }
            }
        }
    });
    if (setError != null) {
        return setError(updatedErrors);
    } else {
        return error;
    }
};

export const validateMixMatchSections = (sections: mix_match_section[]): string => {
    if (!sections || sections.length === 0) {
        return "At least one section is required.";
    }

    for (let i = 0; i < sections.length; i++) {
        const section = sections[i];
        const label = `Section ${i + 1}`;

        if (!section.title.trim()) {
            return `${label} title is required.`;
        }

        if (!section.subtitle.trim()) {
            return `${label} subtitle is required.`;
        }

        if (section.product_selection === "specific" && (!section.products || section.products.length === 0)) {
            return `${label}: Products are required when selection is 'specific'.`;
        }

        if (section.product_selection === "collection" && (!section.collections || section.collections.length === 0)) {
            return `${label}: Collections are required when selection is 'collections'.`;
        }
    }

    return "";
};

export const validateCustomFields = (fields: custom_field[]): string => {
    if (!fields || fields.length === 0) return "";

    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        const label = `Custom field ${i + 1}`;

        if (field.type === "radio" && (!field.options || field.options.length === 0)) {
            return `${label}: Options are required for radio type.`;
        }
    }

    return ""; // ✅ no errors
};

export const generateUniqueId = (): string => {
    return `option_${Math.random().toString(36).substr(2, 9)}`;
};

export const isBundleExpired = (end_date?: string | null) => {
    if (!end_date) return false;
    const UTCEndDate = new Date(end_date);

    const UTCNowDate = new Date();

    return UTCNowDate > UTCEndDate;
};

export const isBundleScheduled = (start_date?: string | null) => {
    if (!start_date) return false;
    const UTCStartDate = new Date(start_date);

    const UTCNowDate = new Date();

    return UTCNowDate < UTCStartDate;
};
export const updateBundleStats: (obj: any) => void = async ({ id, key, shop, appName, view_type, product_ids }) => {
    try {
        const payload = {
            form_id: id,
            [key]: 1,
            view_type: view_type,
            ...(product_ids && { product_ids }),
        };
        await fetch(`${BACKEND_URL}/public/${appName}/bundles/save-clicks-views?shop=${shop}`, {
            method: "post",
            body: JSON.stringify(payload),
            headers: {
                "content-type": "application/json",
            },
        });
    } catch (err) {
        console._log(err);
    }
};

export const trackAbVisitorEvent = (
    bundle: VolumeConfigInterface | BundleBuilderConfigInterface,
    action: "view" | "click",
    view_type: number,
    appName: any,
) => {
    const abConfig = bundle?.ab_config;
    const variantId = bundle?._ab_variant_id;
    const shop = window.kefi_bundles?.shop;
    if (!shop || !bundle?.form_id || !abConfig?.exp_id || !variantId) return;

    let visitorId: string | null = null;
    try {
        visitorId = localStorage.getItem("kefi_visitor_id");
    } catch (error) {
        return;
    }
    if (!visitorId) return;

    try {
        fetch(`${BACKEND_URL}/public/${appName}/bundles/ab-test/save-visitor-event?shop=${shop}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            keepalive: true,
            body: JSON.stringify({
                shop,
                visitor_id: visitorId,
                form_id: bundle.form_id,
                exp_id: abConfig.exp_id,
                variant_uuid: variantId,
                view_type,
                action,
            }),
        }).catch(() => {});
    } catch (error) {
        // Never let tracking failures affect bundle rendering.
    }
};

export const showWeightInfo: (standAlone: boolean) => boolean = (standAlone) => {
    const shopName = standAlone ? window?.kefi_bundles?.shop : window?.shopify?.config?.shop || "";
    const ValidShops: string[] = ["killmachine.myshopify.com", "jsdyqu-sc.myshopify.com"];
    return ValidShops.includes(shopName);
};

export const getWeightUnit: (unit: string) => string = (unit) => {
    if (!unit) {
        return "";
    }
    let unitString = "";
    switch (unit) {
        case "KILOGRAMS":
            unitString = "kg";
            break;
        case "GRAMS":
            unitString = "g";
            break;
        case "OUNCES":
            unitString = "oz";
            break;
        case "POUNDS":
            unitString = "lb";
            break;
        default:
            unitString = "";
    }
    return unitString;
};

export const filterInStockProducts = (product: ProductObj): boolean => {
    if (!product?.variants || !Array.isArray(product.variants)) return false; // No variants → treat as out-of-stock

    return product.variants.some(
        (variant: any) =>
            (typeof variant.quantityAvailable === "number" && variant.quantityAvailable > 0) ||
            variant.availableForSale,
    );
};
function addSubscriptionsToProducts(productsList: any, rawData: any) {
    return productsList.map((product: any) => {
        const rawProduct = rawData.nodes.find((item: any) => item.id === product.id);

        const oldSubscriptions = product?.subscriptions || [];
        product.subscriptions = [];
        product.oneTimePurchase = product.oneTimePurchase ?? true;
        product.metafield = rawProduct?.metafield;
        product.collections = rawProduct?.collections?.nodes?.map((c: any) => c.id) || [];

        if (rawProduct && rawProduct.sellingPlanGroups && rawProduct.sellingPlanGroups.nodes) {
            rawProduct.sellingPlanGroups.nodes.forEach((group: any) => {
                group.sellingPlans.nodes.forEach((plan: any) => {
                    const subb = oldSubscriptions?.find((ss: any) => ss.id == plan.id);
                    const subscription: any = {
                        id: plan.id,
                        name: plan.name,
                        checked: subb?.checked ?? true,
                        discountType: "none",
                        discountValue: 0,
                        recurringDeliveries: plan.recurringDeliveries,
                        billingPolicy: plan.billingPolicy,
                        deliveryPolicy: plan.deliveryPolicy,
                    };

                    // checkng the discountType and discountValue based on price adjustments
                    const adjustmentValue = plan.priceAdjustments[0]?.adjustmentValue;

                    if (adjustmentValue) {
                        if (adjustmentValue.price) {
                            // Fixed amount price adjustment
                            subscription.discountType = "fixed";
                            subscription.discountValue = +adjustmentValue.price.amount;
                        } else if (adjustmentValue.adjustmentAmount) {
                            // Flat price adjustment
                            subscription.discountType = "flat";
                            subscription.discountValue = +adjustmentValue.adjustmentAmount.amount;
                        } else if (adjustmentValue.adjustmentPercentage) {
                            // Percentage price adjustment
                            subscription.discountType = "percentage";
                            subscription.discountValue = +adjustmentValue.adjustmentPercentage;
                        }
                    }

                    product.subscriptions.push(subscription);
                });
            });
        }

        return product;
    });
}

function updateVariantPrices(finalData: any, nodes: any, required_product: boolean = false, bundle_type: string = "") {
    const newProductsArr: any = [];

    finalData?.forEach((product: any) => {
        const matchingProduct = nodes?.nodes?.find((node: any) => node.id === product.id);

        if (matchingProduct) {
            let filteredVariants = matchingProduct?.variants?.nodes || [];
            if (
                BundleTypes.THANKYOUPAGE == bundle_type ||
                BundleTypes.MIX_MATCH == bundle_type ||
                BundleTypes.MIX_MATCH_SECTIONAL == bundle_type ||
                BundleTypes.STANDARD == bundle_type ||
                BundleTypes.BXGY == bundle_type ||
                (bundle_type === BundleTypes.PRODUCT_ADDONS && !required_product)
            ) {
                const originalVariantIds = product?.variants?.map((v: any) => v.id) || [];
                filteredVariants = matchingProduct?.variants?.nodes?.filter((variant: any) =>
                    originalVariantIds.includes(variant.id),
                );
            }
            const updatedProduct = {
                ...product,
                options: matchingProduct?.options || [],
                title: matchingProduct?.title,
                handle: product?.handle ? product?.handle : matchingProduct?.handle,
                metafield: matchingProduct?.metafield,
                metafield2: matchingProduct?.metafield2,
                metafield3: matchingProduct?.metafield3,
                metafield4: matchingProduct?.metafield4,
                metafield5: matchingProduct?.metafield5,
                metafield6: matchingProduct?.metafield6,
                tags: matchingProduct?.tags,
                description: matchingProduct?.description,
                descriptionHtml: matchingProduct?.descriptionHtml,
                variantsCount: matchingProduct?.variantsCount,
                selectedVariants: [],
                images:
                    matchingProduct?.images?.nodes?.map((image: any) => ({
                        id: image.id,
                        originalSrc: image.url,
                        altText: image.altText || "",
                    })) || [],
                media: matchingProduct?.media?.edges?.map((edge: any) => edge.node) || product?.media || [],
                variants: filteredVariants.map((variant: any) => {
                    return {
                        price: variant.price.amount,
                        required_product: required_product,
                        weight: variant.weight,
                        weight_unit: variant.weightUnit,
                        compareAtPrice:
                            variant?.compareAtPrice?.amount && +variant?.compareAtPrice.amount >= +variant.price.amount
                                ? variant.compareAtPrice.amount
                                : variant.price.amount,
                        sellingPlanIds:
                            variant?.sellingPlanAllocations?.nodes?.map((node: any) => node.sellingPlan.id) || [],
                        get displayName() {
                            return this.title;
                        },
                        id: variant.id,
                        selectedOptions: variant.selectedOptions,
                        title:
                            variant?.title?.toLowerCase() == "default title" ? matchingProduct?.title : variant?.title,
                        image: { originalSrc: variant.image?.url },
                        quantityAvailable: variant.quantityAvailable,
                        availableForSale: variant.availableForSale,
                        sku: variant?.sku,
                        metafield: variant?.metafield,
                        capacityValue: getCapacityValue(variant?.capacityValues?.value),
                    };
                }),
            };

            newProductsArr.push(updatedProduct);
        } else {
            if (
                window.kefi_bundles.shop === "verde-legion.myshopify.com" ||
                window.kefi_bundles.shop === "bundle-test-28.myshopify.com"
            ) {
                const defaultProduct = {
                    ...product,
                    variants:
                        product.variants?.map((variant: any) => ({
                            ...variant,
                            quantityAvailable: 100,
                            availableForSale: true,
                        })) || [],
                };

                newProductsArr.push(defaultProduct);
            }
        }
    });

    return newProductsArr;
}

//must be called once per config not more than that
function syncFlatFixedDiscountValues(
    config: VolumeConfigInterface &
        StandardConfigInterface &
        BxgyConfigInterface &
        MixMatchConfigInterface &
        MixMatchSectionalConfigInterface &
        BuyNConfigInterface,
) {
    switch (config.bundle_type) {
        case BundleTypes.BXGY:
        case BundleTypes.STANDARD:
            {
                if (
                    (config.discount_type == DISCOUNT_TYPES.FIXED || config.discount_type == DISCOUNT_TYPES.FLAT) &&
                    config.discount_value
                ) {
                    config.discount_value = config.discount_value * window.kefi_bundles.localization.rate;
                }
            }
            break;
        case BundleTypes.VOLUME_DISCOUNT:
            config.volume_discounts.forEach((discount) => {
                if (
                    (discount.discount_type == DISCOUNT_TYPES.FIXED || discount.discount_type == DISCOUNT_TYPES.FLAT) &&
                    discount.discount_value
                ) {
                    discount.discount_value = discount.discount_value * window.kefi_bundles.localization.rate;
                }

                if (discount?.bundle_products && discount?.bundle_products?.length > 0) {
                    discount?.bundle_products.forEach((bp) => {
                        // it doesnt have fixed option in it
                        if (bp.discountType == DISCOUNT_TYPES.FLAT && bp.discountValue) {
                            bp.discountValue = bp.discountValue * window.kefi_bundles.localization.rate;
                        }
                    });
                }
                if (discount?.upsell_products && discount?.upsell_products?.length > 0) {
                    discount?.upsell_products.forEach((bp) => {
                        // it doesnt have fixed option in it
                        if (bp.discountType == DISCOUNT_TYPES.FLAT && bp.discountValue) {
                            bp.discountValue = bp.discountValue * window.kefi_bundles.localization.rate;
                        }
                    });
                }
            });

            break;
        case BundleTypes.MIX_MATCH:
            config.discount_options.forEach((discount) => {
                if (
                    (discount.discountType == DISCOUNT_TYPES.FIXED || discount.discountType == DISCOUNT_TYPES.FLAT) &&
                    discount.discountValue
                ) {
                    discount.discountValue = discount.discountValue * window.kefi_bundles.localization.rate;
                }
                if (discount.discountType == DISCOUNT_TYPES.PERCENTAGE && discount?.max_discount_allowed != null) {
                    discount.max_discount_allowed =
                        discount.max_discount_allowed * window.kefi_bundles.localization.rate;
                }
            });
            break;
        case BundleTypes.BUY_N:
            config?.discount_options?.forEach((discount: BuyNOptions) => {
                if (discount?.discount_type == DISCOUNT_TYPES.FLAT && discount?.discount_value) {
                    discount.discount_value = discount.discount_value * window.kefi_bundles.localization.rate;
                }
            });
            break;
        case BundleTypes.MIX_MATCH_SECTIONAL:
            config.discount_options.forEach((discount) => {
                if (
                    (discount.discountType == DISCOUNT_TYPES.FIXED || discount.discountType == DISCOUNT_TYPES.FLAT) &&
                    discount.discountValue
                ) {
                    discount.discountValue = discount.discountValue * window.kefi_bundles.localization.rate;
                }
                if (discount.discountType == DISCOUNT_TYPES.PERCENTAGE && discount?.max_discount_allowed != null) {
                    discount.max_discount_allowed =
                        discount.max_discount_allowed * window.kefi_bundles.localization.rate;
                }
                if (config.tier_discount_basis == "bundle_total") {
                    discount.quantity = discount.quantity * window.kefi_bundles.localization.rate;
                }
            });
            break;
    }
}

export function isValidSelector(selector: string): boolean {
    try {
        document.querySelector(selector);
        return true;
    } catch {
        return false;
    }
}

export function generateRandomUniqueId(): string {
    return uuidv4();
}

export const applyCartDiscountFromCart = async (
    storefrontAccessToken: string,
    cartId: string,
    discountCodes: string[],
    standalone = false,
) => {
    const variables = {
        cartId: `gid://shopify/Cart/${cartId}`,
        discountCodes,
    };
    try {
        const userShopname = !standalone ? shopify.config.shop : window.kefi_bundles.shop;
        const response = await fetch(`https://${userShopname}/api/2026-04/graphql.json`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
            },
            body: JSON.stringify({
                query: `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {
                        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                            cart {
                                id
                                discountCodes {
                                    code
                                    applicable
                                }
                            }
                            userErrors {
                                field
                                message
                                message
                            }
                        }
                    }
                `,
                variables,
            }),
        });

        const data = await response.json();
        return data?.data?.cartDiscountCodesUpdate;
    } catch (error) {
        console.error("Error applying cart discount:", error);
        throw error;
    }
};

// CartLayout Constants
export const CartItemPositions = {
    DEFAULT: "default",
    TOP: "top",
    BOTTOM: "bottom",
    LEFT: "left",
    RIGHT: "right",
    UNDER_PRICE: "under_price",
    UNDER_TITLE: "under_title",
    ABOVE_QTY: "above_qty",
    UNDER_QTY: "under_qty",
    HEADER: "header",
} as const;

export type CartItemPosition = (typeof CartItemPositions)[keyof typeof CartItemPositions];

//using in BB
export const BBProductCardSizes = [
    { label: "Small", value: "small" },
    { label: "Medium", value: "medium" },
    { label: "Large", value: "large" },
];

/**
 * Option names and values come back translated from the Storefront API (@inContext), while swatch
 * configs are written in the admin's locale. Resolving by name alone breaks on translated storefronts,
 * so we match on the locale-independent option id first, then the name, then the position.
 */
export const findSwatchEntryForOption = <
    T extends { optionId?: string; optionIds?: string[]; variantType?: string; name?: string } = any,
>(
    entries: T[] | undefined,
    option: { id?: string; name?: string; values?: string[] },
    optionIndex: number,
    totalOptions: number,
): T | undefined => {
    if (!entries?.length) return undefined;

    const entryName = (entry: T) => entry.variantType ?? entry.name;

    // Per-product metafields carry a single `optionId`; bundle-level swatchOptions group several
    // products, each with its own ProductOption id, so they carry `optionIds`.
    const byId =
        option?.id &&
        entries.find((entry) => entry.optionId === option.id || entry.optionIds?.includes(option.id as string));
    if (byId) return byId;

    const byName = entries.find((entry) => entryName(entry)?.toLowerCase() === option?.name?.toLowerCase());
    if (byName) return byName;

    // Positional fallback for configs saved before option ids were stored (e.g. a metafield written in
    // another language). Only used when the saved set still lines up with the product's current one:
    // same number of options, and the same number of values inside the matched one.
    if (entries.length !== totalOptions) return undefined;

    const positional = entries[optionIndex] as T & { swatchValues?: unknown[] };
    const savedValueCount = positional?.swatchValues?.length;

    if (option?.values?.length && savedValueCount && savedValueCount !== option.values.length) return undefined;

    return positional;
};

/** Same idea as findSwatchEntryForOption, one level down: a single option value (e.g. "Rose gold"). */
export const findSwatchEntryForValue = <T extends { value?: string; name?: string; index?: number } = any>(
    entries: T[] | undefined,
    value: string,
    valueIndex: number,
    totalValues: number,
): T | undefined => {
    if (!entries?.length) return undefined;

    const entryValue = (entry: T) => entry.value ?? entry.name;

    const byValue = entries.find((entry) => entryValue(entry)?.toLowerCase() === value?.toLowerCase());
    if (byValue) return byValue;

    const byIndex = entries.find((entry) => entry.index === valueIndex);
    if (byIndex) return byIndex;

    if (entries.length === totalValues) return entries[valueIndex];

    return undefined;
};

export const buildMetafieldFromSwatchOptions = ({
    product,
    bundleConfig,
}: {
    product: ProductObj;
    bundleConfig: any;
}) => {
    const swatchOptions: SwatchOption[] = bundleConfig?.swatchOptions || [];
    let existingMetaOptions: any[] = [];

    try {
        existingMetaOptions = product.metafield?.value ? JSON.parse(product.metafield.value).options || [] : [];
    } catch (error) {
        existingMetaOptions = [];
    }

    const productOptions = product.options || [];

    const options = productOptions.map((opt, optIndex) => {
        const existingMeta = findSwatchEntryForOption(existingMetaOptions, opt, optIndex, productOptions.length);
        const matchingSwatch = findSwatchEntryForOption(swatchOptions, opt, optIndex, productOptions.length);
        const metaSwatchOption = existingMeta;

        //  User touched layout check for this option
        const userTouchedLayout = bundleConfig?.SwatchesBundleConfigTouchedRef?.current?.[opt.name];

        // Layout decision with fallback even if empty string
        let layout = "dropdown"; // default

        if (bundleConfig?.source === "modalPopup") {
            layout = userTouchedLayout
                ? matchingSwatch?.swatchType || "dropdown"
                : (existingMeta && getSwatchLayoutValue(existingMeta)) || "dropdown";
        } else {
            if (userTouchedLayout) {
                layout =
                    matchingSwatch?.swatchType || (existingMeta && getSwatchLayoutValue(existingMeta)) || "dropdown";
            } else {
                layout =
                    (existingMeta && getSwatchLayoutValue(existingMeta)) || matchingSwatch?.swatchType || "dropdown";
            }
        }

        const safeLayout = layout || "dropdown"; //  Ensure never empty/undefined for includes below

        // Derive displayType, swatchType, swatchLayout from layout
        let displayType: "swatch" | "label" | "dropdown" = "dropdown";
        let swatchType: "color" | "image" | null = null;
        let swatchLayout: "dropdown" | "inline" | null = null;

        if (safeLayout.includes("color")) swatchType = "color";
        if (safeLayout.includes("image")) swatchType = "image";

        if (safeLayout.includes("swatch")) {
            displayType = "swatch";
            swatchLayout = "inline";
        } else if (safeLayout.includes("dropdown")) {
            displayType = safeLayout.includes("color") || safeLayout.includes("image") ? "swatch" : "dropdown";
            swatchLayout = "dropdown";
        } else if (safeLayout === "label") {
            displayType = "label";
            swatchType = null;
            swatchLayout = null;
        }

        //  Build swatchValues (color/image for each value)
        const optionValues = opt.values || [];
        const swatchValues = optionValues.map((value: string, valueIndex: number) => {
            const colorObj = findSwatchEntryForValue(matchingSwatch?.colors, value, valueIndex, optionValues.length);
            const imageObj = findSwatchEntryForValue(matchingSwatch?.images, value, valueIndex, optionValues.length);
            const metaSwatch = findSwatchEntryForValue(
                metaSwatchOption?.swatchValues,
                value,
                valueIndex,
                optionValues.length,
            );

            const productColor =
                colorObj?.products?.find((p) => p.productId === product.id)?.color ||
                colorObj?.color ||
                metaSwatch?.color ||
                "";

            const productImage =
                imageObj?.products?.find((p) => p.productId === product.id)?.image ||
                imageObj?.image ||
                metaSwatch?.image ||
                "";

            return {
                value,
                index: valueIndex,
                color: productColor,
                image: productImage,
            };
        });

        //  Final field picking logic
        let finalDisplayType: "swatch" | "label" | "dropdown" = displayType;
        let finalSwatchType: "color" | "image" | null = swatchType;
        let finalSwatchLayout: "dropdown" | "inline" | null = swatchLayout;
        let finalSwatchValues = swatchValues;

        if (!userTouchedLayout && existingMeta) {
            finalDisplayType = existingMeta.displayType || finalDisplayType;
            finalSwatchType = existingMeta.swatchType ?? finalSwatchType;
            finalSwatchLayout = existingMeta.swatchLayout ?? finalSwatchLayout;
            // Keep the locally built values: their `value` is in the viewer's locale, while the saved
            // metafield holds whichever locale it was written in. Colors/images already fall back to it.
            finalSwatchValues = finalSwatchValues?.length ? finalSwatchValues : existingMeta.swatchValues || [];
        }

        return {
            variantType: opt.name,
            optionId: opt.id,
            displayType: finalDisplayType,
            swatchType: finalSwatchType,
            swatchValues: finalSwatchValues,
            productId: product.id,
            swatchLayout: finalSwatchLayout,
        };
    });

    return {
        value: JSON.stringify({ options }),
        type: "json",
    };
};

export const generateSwatchConfigsFromProductMap = (newMap: SwatchesProductsMap, oldMap?: SwatchesProductsMap) => {
    if (!newMap) return [];

    const final: any[] = [];

    Object.entries(newMap).forEach(([productId, optionMap]) => {
        const isChanged = Object.entries(optionMap).some(([optionName, { layout, values }]) => {
            const oldValues = oldMap?.[productId]?.[optionName]?.values;
            const oldLayout = oldMap?.[productId]?.[optionName]?.layout;
            return layout !== oldLayout || JSON.stringify(values) !== JSON.stringify(oldValues);
        });

        if (!isChanged) return; // nothing changed, skip whole product

        // add all options for this product since any one changed
        Object.entries(optionMap).forEach(([optionName, { layout, optionId, values }]) => {
            const { displayType, swatchType, swatchLayout } = getSwatchDisplayMeta(layout);

            const swatchValues = Object.entries(values).map(([val, { color, image, index }], valueIndex) => ({
                value: val,
                index: index ?? valueIndex,
                color,
                image,
            }));

            final.push({
                variantType: optionName,
                optionId,
                displayType,
                swatchType,
                swatchLayout,
                swatchValues,
                productId,
            });
        });
    });

    return final;
};

export const getSwatchDisplayMeta = (layout: string) => {
    if (layout === "color_swatch") return { displayType: "swatch", swatchType: "color", swatchLayout: "inline" };
    if (layout === "image_swatch") return { displayType: "swatch", swatchType: "image", swatchLayout: "inline" };
    if (layout === "color_dropdown") return { displayType: "swatch", swatchType: "color", swatchLayout: "dropdown" };
    if (layout === "image_dropdown") return { displayType: "swatch", swatchType: "image", swatchLayout: "dropdown" };
    if (layout === "label") return { displayType: "label", swatchType: null, swatchLayout: null };
    return { displayType: "dropdown", swatchType: null, swatchLayout: null };
};

export const getSwatchLayoutValue = (option: any): string => {
    const { displayType, swatchLayout, swatchType } = option;

    if (displayType === "label") return "label";
    if (displayType === "dropdown") return "default";

    if (displayType === "swatch") {
        if (swatchLayout === "inline") {
            if (swatchType === "color") return "color_swatch";
            if (swatchType === "image") return "image_swatch";
        }
        if (swatchLayout === "dropdown") {
            if (swatchType === "color") return "color_dropdown";
            if (swatchType === "image") return "image_dropdown";
        }
    }

    return "default";
};

export const updateRewardFreeGifts = async (
    productsList: any[],
    storefrontAccessToken: string,
    standalone?: boolean,
) => {
    if (!storefrontAccessToken) {
        productsList.forEach((product) => {
            product.variants.forEach((v: any) => {
                v.availableForSale = true;
                v.quantityAvailable = 1000;
            });
        });

        return productsList;
    }

    const productIds = productsList.reduce((acc: any[], product: any) => {
        if (product.id && typeof product.id === "string") {
            acc.push(product.id.split("/").pop());
        }
        return acc;
    }, []);

    const productQuery = productIds.map((id: any) => `id:${id}`).join(" OR ");

    const context = getStoreContext(standalone);

    const query = `
        query getProducts($query: String) ${context} {
            products(first: 250, query: $query) {
                nodes {
                title
                id
                images(first:5){
                    nodes{
                        id
                        altText
                        originalSrc
                    }
                }
                options{
                    id
                    name
                    values
                }
                 metafield(namespace: "kefi_swatches", key: "swatches") {
                        value
                        type
                 }
                sellingPlanGroups(first: 10) {
                    nodes {
                    sellingPlans(first: 10) {
                        nodes {
                        id
                        name
                        recurringDeliveries
                        billingPolicy {
                            __typename
                            ... on SellingPlanRecurringBillingPolicy {
                                interval
                                intervalCount
                            }
                        }
                        deliveryPolicy {
                            __typename
                            ... on SellingPlanRecurringDeliveryPolicy {
                                interval
                                intervalCount
                            }
                        }
                        priceAdjustments {
                            adjustmentValue {
                            ... on SellingPlanFixedAmountPriceAdjustment {
                                adjustmentAmount {
                                amount
                                }
                            }
                            ... on SellingPlanFixedPriceAdjustment {
                                price {
                                amount
                                }
                            }
                            ... on SellingPlanPercentagePriceAdjustment {
                                adjustmentPercentage
                            }
                            }
                        }
                        }
                    }
                    }
                }
                variants(first: ${VARIANTS_PAGE_SIZE}) {
                    ${VARIANTS_CONNECTION_FIELDS}
                }
                }
            }
        }
    `;

    const variables = {
        query: productQuery,
    };

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontAccessToken);
    myHeaders.append("Cookie", "request_method=POST");

    const raw = JSON.stringify({
        query,
        variables,
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        // redirect: "follow",
    };

    try {
        const userShopname = !standalone ? shopify.config.shop : window.kefi_bundles.shop;
        const response = await fetch(`https://${userShopname}/api/2025-07/graphql.json`, requestOptions);
        const result = await response.json();

        if (result?.errors?.length) {
            return productsList;
        }
        const data = result.data.products;

        await fetchRemainingVariants(data.nodes, context, storefrontAccessToken, userShopname);

        const finalData = addSubscriptionsToProducts(productsList, data);
        const newProductsList = updateVariantPricesFreeGift(finalData, data);

        return newProductsList;
    } catch (error) {
        console.error("Error fetching products:", error);
        return productsList;
    }
};

function updateVariantPricesFreeGift(finalData: any, nodes: any, required_product: boolean = false) {
    const newProductsArr: any = [];

    finalData?.forEach((product: any) => {
        const matchingProduct = nodes?.nodes?.find((node: any) => node.id === product.id);
        if (!matchingProduct) return;

        // Normalize allowed variant IDs (strip Shopify GIDs)
        const allowedVariantIds = new Set(product.variants?.map((v: any) => v.id?.toString().split("/").pop()));

        const filteredVariants =
            matchingProduct.variants?.nodes?.filter((variant: any) => {
                const variantId = variant.id?.toString().split("/").pop();
                return allowedVariantIds.has(variantId);
            }) ?? [];

        const updatedProduct = {
            ...product,
            options: matchingProduct?.options || [],
            title: matchingProduct?.title,
            handle: product?.handle ?? matchingProduct?.handle,
            metafield: matchingProduct?.metafield,
            description: matchingProduct?.description,
            descriptionHtml: matchingProduct?.descriptionHtml,
            images: matchingProduct?.images?.nodes || [],
            variants: filteredVariants.map((variant: any) => ({
                price: variant.price.amount,
                required_product: required_product,
                compareAtPrice:
                    variant?.compareAtPrice?.amount && +variant?.compareAtPrice.amount >= +variant.price.amount
                        ? variant.compareAtPrice.amount
                        : variant.price.amount,
                get displayName() {
                    return this.title;
                },
                id: variant.id,
                selectedOptions: variant.selectedOptions,
                title: variant?.title?.toLowerCase() === "default title" ? matchingProduct?.title : variant?.title,
                image: { originalSrc: variant.image?.url },
                quantityAvailable: variant.quantityAvailable,
                sku: variant?.sku,
                availableForSale: variant.availableForSale,
                metafield: variant?.metafield,
                capacityValue: getCapacityValue(variant?.capacityValues?.value),
            })),
        };

        newProductsArr.push(updatedProduct);
    });

    return newProductsArr;
}

export const fetchVariantImages = async (standalone: boolean, storefrontAccessToken: string, variantIds: string[]) => {
    if (!variantIds?.length) return {};

    const query = `
    query getVariantImages($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on ProductVariant {
          id
          image {
            id
            src
            altText
          }
        }
      }
    }
  `;

    const userShopname = !standalone ? shopify.config.shop : window.kefi_bundles.shop;

    const response = await fetch(`https://${userShopname}/api/2025-01/graphql.json`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
        },
        body: JSON.stringify({
            query,
            variables: { ids: variantIds },
        }),
    });

    const json = await response.json();

    if (json.errors) {
        console.error("GraphQL errors:", json.errors);
        return {};
    }

    // Map variant ID → image
    const imageMap: any = {};
    json.data.nodes.forEach((variant: any) => {
        if (variant?.id && variant?.image) {
            imageMap[variant.id] = variant.image;
        }
    });

    return imageMap;
};

export const fetchProductsByIds = async (productIds: string[], standalone: boolean, storefrontAccessToken: string) => {
    if (!productIds?.length) return [];

    const context = getStoreContext(standalone);

    const query = `
    query getProducts($ids: [ID!]!) ${context} {
      nodes(ids: $ids) {
        ... on Product {
          id
          title
          handle
          description
          descriptionHtml
          options {
            id
            name
            values
          }
          variantsCount {
                count
                precision
            }
          variants(first: ${VARIANTS_PAGE_SIZE}) {
            ${VARIANTS_CONNECTION_FIELDS}
          }
        }
      }
    }
  `;

    const variables = { ids: productIds };

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontAccessToken);
    myHeaders.append("Cookie", "request_method=POST");
    const raw = JSON.stringify({
        query,
        variables,
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        // redirect: "follow",
    };
    try {
        const userShopname = !standalone ? shopify.config?.shop : window.kefi_bundles?.shop;

        const response = await fetch(`https://${userShopname}/api/2025-07/graphql.json`, requestOptions);

        const result = await response.json();

        if (result?.errors?.length) {
            console.error("GraphQL errors:", result.errors);

            return [];
        }

        const data: any = result?.data?.nodes || [];
        if (!data.length) {
            console.warn("No products returned from API.");
        }

        await fetchRemainingVariants(data, context, storefrontAccessToken, userShopname);

        return data;
    } catch (err) {
        console.error("Failed to fetch products:", err);

        return [];
    }
};

export const fetchVariantsByIds = async (variantIds: string[], standalone: boolean, storefrontAccessToken: string) => {
    if (!variantIds?.length) return [];

    const context = getStoreContext(standalone);

    const query = `
    query getVariants($ids: [ID!]!) ${context} {
      nodes(ids: $ids) {
        ... on ProductVariant {
          id
          title
          availableForSale
          quantityAvailable
          price {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
          }
          selectedOptions {
            name
            value
          }
          image {
            url
          }
          product {
            id
            title
            handle
            description
            descriptionHtml
            options {
              id
              name
              values
            }
          }
        }
      }
    }
  `;

    const variables = { ids: variantIds };

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontAccessToken);
    myHeaders.append("Cookie", "request_method=POST");

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ query, variables }),
    };

    try {
        const userShopname = !standalone ? shopify.config?.shop : window.kefi_bundles?.shop;

        const response = await fetch(`https://${userShopname}/api/2025-07/graphql.json`, requestOptions);

        const result = await response.json();

        if (result?.errors?.length) {
            console.error("GraphQL errors:", result.errors);
            return [];
        }

        const data: any = result?.data?.nodes || [];
        if (!data.length) {
            console.warn("No variants returned from API.");
        }

        return data;
    } catch (err) {
        console.error("Failed to fetch variants:", err);
        return [];
    }
};

export const checkBundleStockAvailability = (
    products: any[],
    requestedQty: number,
    formId: string,
): { isValid: boolean; minAvailableQty?: number } => {
    let minAvailableQty: number | undefined;
    let minProduct: any = null;
    let minVariant: any = null;

    //  Find minimum available quantity among all selected variants
    for (const product of products) {
        for (const variant of product.selectedVariants || []) {
            const availableQty = variant.quantityAvailable;
            if (availableQty !== undefined) {
                if (minAvailableQty === undefined || availableQty < minAvailableQty) {
                    minAvailableQty = availableQty;
                    minProduct = product;
                    minVariant = variant;
                }
            }
        }
    }

    //  If requested quantity exceeds the minimum available, show error
    if (minAvailableQty !== undefined && requestedQty > minAvailableQty) {
        renderBundleErrorMessage(
            `Only ${minAvailableQty} ${minProduct?.title || "Product"} (${
                minVariant?.title || "Variant"
            }) are available`,
            formId,
            {
                fontSize: "15px",
                fontWeight: "500",
                paddingBottom: "10px",
            },
        );
        return { isValid: false, minAvailableQty };
    }

    return { isValid: true, minAvailableQty };
};

export const handleCopyText = (text: string, showShopifyToast = false) => {
    navigator.clipboard.writeText(text);
    if (showShopifyToast) {
        shopify.toast.show("Bundle Builder Link copied");
    }
};

export const mergeById = (products: any[]) => {
    return Object.values(
        products.reduce((acc: any, product: any) => {
            if (!acc[product.id]) {
                acc[product.id] = { ...product };
            } else {
                acc[product.id].quantity += product.quantity;
            }
            return acc;
        }, {}),
    );
};

export function priceWithVat(price: number, percent: number) {
    return Math.round((price + (price * percent) / 100) * 100) / 100;
}

export const SPIRIT_EMBASSY_SHOPS = ["thespiritsembassy-dev.myshopify.com", "the-spirits-embassy.myshopify.com"];

export const isSpiritEmbassyShop = () => {
    return SPIRIT_EMBASSY_SHOPS.includes(window?.kefi_bundles?.shop);
};
